var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterfallmethodAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-451",
    d: "M77.66,242.32c-95.18,54.95-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,187.37,77.66,242.32Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-451"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-451",
    points: "484.93 358.44 352.07 435.14 94.5 286.47 227.36 209.76 484.93 358.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M57.24,354.52,26.9,337a.32.32,0,0,1,0-.61l74.68-43.12a1.17,1.17,0,0,1,1.06,0L133,310.79a.33.33,0,0,1,0,.62L58.31,354.52A1.19,1.19,0,0,1,57.24,354.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M108.09,384.17,77.75,366.64c-.3-.17-.3-.44,0-.61l74.67-43.12a1.19,1.19,0,0,1,1.07,0l30.34,17.53a.33.33,0,0,1,0,.62l-74.68,43.11A1.17,1.17,0,0,1,108.09,384.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M158.93,413.82l-30.34-17.53a.32.32,0,0,1,0-.61l74.68-43.12a1.17,1.17,0,0,1,1.06,0l30.34,17.53a.33.33,0,0,1,0,.62L160,413.82A1.19,1.19,0,0,1,158.93,413.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M209.78,443.47l-30.34-17.53c-.3-.17-.3-.45,0-.61l74.67-43.12a1.17,1.17,0,0,1,1.06,0l30.34,17.53a.33.33,0,0,1,0,.62l-74.67,43.11A1.17,1.17,0,0,1,209.78,443.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M260.62,473.12l-30.34-17.53a.32.32,0,0,1,0-.61L305,411.86a1.19,1.19,0,0,1,1.07,0l30.34,17.53a.33.33,0,0,1,0,.62l-74.68,43.11A1.17,1.17,0,0,1,260.62,473.12Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.56,178.41a3.83,3.83,0,0,1,1-2l4.09-3.76a2.45,2.45,0,0,0,.69-2l-.77-4.46a.85.85,0,0,0-.39-.62h0l-4.85-2.8h0a.75.75,0,0,0-.84.08L70.74,164l1.7-4.59a1,1,0,0,0-.47-1.27h0l-4.85-2.8h0a1,1,0,0,0-.32-.13l-3.08-.69a1.67,1.67,0,0,0-1.75.81l-2.9,5.52a2.83,2.83,0,0,1-1.15,1.06l-.13-.44a1,1,0,0,0-.39-.54h0l-4.86-2.81h0a.79.79,0,0,0-.91.13L47,161.85a2.58,2.58,0,0,0-.87,2l.27,4.39a3.51,3.51,0,0,1-.72,2.13c-.75.9-1.47,1.85-2.14,2.83a2.38,2.38,0,0,1-1.88,1l-3-.15A1.92,1.92,0,0,0,37,175l-2.79,6.25a1.18,1.18,0,0,0,.48,1.5h0l3.29,1.9a1.45,1.45,0,0,1,.07.85,26.53,26.53,0,0,0-.51,3,3.79,3.79,0,0,1-1,2l-4.09,3.76a2.49,2.49,0,0,0-.69,2l.77,4.46a.86.86,0,0,0,.37.61h0l4.88,2.81h0a.78.78,0,0,0,.84-.09L40.38,203l-1.69,4.59a1,1,0,0,0,.41,1.25h0L44,211.61v0a1.17,1.17,0,0,0,.34.15l3.08.69a1.65,1.65,0,0,0,1.74-.81l2.9-5.51A2.85,2.85,0,0,1,53.18,205l.13.44a.92.92,0,0,0,.4.54h0l4.82,2.78h0l.05,0h0a.8.8,0,0,0,.89-.13l4.61-3.63a2.59,2.59,0,0,0,.88-2l-.28-4.39a3.51,3.51,0,0,1,.72-2.13,35,35,0,0,0,2.14-2.83,2.38,2.38,0,0,1,1.88-1l3,.15a1.89,1.89,0,0,0,1.7-1l2.79-6.25a1.18,1.18,0,0,0-.62-1.58l-2.4-1a1.5,1.5,0,0,1-.82-1.66A26.53,26.53,0,0,0,73.56,178.41ZM48.93,192c-.9-5.25,2.42-12.7,7.42-16.63A10.14,10.14,0,0,1,61.61,173a7.94,7.94,0,0,1,.58,1.94c.9,5.25-2.42,12.7-7.42,16.63a10,10,0,0,1-5.24,2.34A7.81,7.81,0,0,1,48.93,192Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.56,178.41a3.83,3.83,0,0,1,1-2l4.09-3.76a2.45,2.45,0,0,0,.69-2l-.77-4.46a.85.85,0,0,0-.39-.62h0l-4.85-2.8h0a.75.75,0,0,0-.84.08L70.74,164l1.7-4.59a1,1,0,0,0-.47-1.27h0l-4.85-2.8h0a1,1,0,0,0-.32-.13l-3.08-.69a1.67,1.67,0,0,0-1.75.81l-2.9,5.52a2.83,2.83,0,0,1-1.15,1.06l-.13-.44a1,1,0,0,0-.39-.54h0l-4.86-2.81h0a.79.79,0,0,0-.91.13L47,161.85a2.58,2.58,0,0,0-.87,2l.27,4.39a3.51,3.51,0,0,1-.72,2.13c-.75.9-1.47,1.85-2.14,2.83a2.38,2.38,0,0,1-1.88,1l-3-.15A1.92,1.92,0,0,0,37,175l-2.79,6.25a1.18,1.18,0,0,0,.48,1.5h0l3.29,1.9a1.45,1.45,0,0,1,.07.85,26.53,26.53,0,0,0-.51,3,3.79,3.79,0,0,1-1,2l-4.09,3.76a2.49,2.49,0,0,0-.69,2l.77,4.46a.86.86,0,0,0,.37.61h0l4.88,2.81h0a.78.78,0,0,0,.84-.09L40.38,203l-1.69,4.59a1,1,0,0,0,.41,1.25h0L44,211.61v0a1.17,1.17,0,0,0,.34.15l3.08.69a1.65,1.65,0,0,0,1.74-.81l2.9-5.51A2.85,2.85,0,0,1,53.18,205l.13.44a.92.92,0,0,0,.4.54h0l4.82,2.78h0l.05,0h0a.8.8,0,0,0,.89-.13l4.61-3.63a2.59,2.59,0,0,0,.88-2l-.28-4.39a3.51,3.51,0,0,1,.72-2.13,35,35,0,0,0,2.14-2.83,2.38,2.38,0,0,1,1.88-1l3,.15a1.89,1.89,0,0,0,1.7-1l2.79-6.25a1.18,1.18,0,0,0-.62-1.58l-2.4-1a1.5,1.5,0,0,1-.82-1.66A26.53,26.53,0,0,0,73.56,178.41ZM48.93,192c-.9-5.25,2.42-12.7,7.42-16.63A10.14,10.14,0,0,1,61.61,173a7.94,7.94,0,0,1,.58,1.94c.9,5.25-2.42,12.7-7.42,16.63a10,10,0,0,1-5.24,2.34A7.81,7.81,0,0,1,48.93,192Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,201.79a1.16,1.16,0,0,0-1.64-.37L40.38,203l-1.7,4.59a1,1,0,0,0,.41,1.25l4.82,2.77a1,1,0,0,1-.37-1.22l2.09-5.64a2,2,0,0,0-.48-1.94A9.6,9.6,0,0,1,44.35,201.79Zm14.21,7a.92.92,0,0,1-.39-.53l-1-3.46a1.06,1.06,0,0,0-1.46-.67,12,12,0,0,1-1.89.63,2.32,2.32,0,0,0-.6.25l.13.44a1,1,0,0,0,.4.54h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.63,194.37c-4.32,3.4-8.47,3.07-10.1-.46a10.11,10.11,0,0,0,5.24-2.34c5-3.93,8.33-11.38,7.42-16.63a7.33,7.33,0,0,0-.58-1.93c2.74-.24,4.87,1.41,5.44,4.73C68,183,64.63,190.44,59.63,194.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.54,173.93a2,2,0,0,1-.84.19l-3-.15a1.89,1.89,0,0,0-1.23.45l4.86,2.8a2,2,0,0,1,1.23-.45l3,.15a2,2,0,0,0,.85-.16Zm10-15.83a.79.79,0,0,0-.91.12L47,161.85a2.59,2.59,0,0,0-.76,1.21l4.86,2.8a2.52,2.52,0,0,1,.76-1.21L56.5,161a.81.81,0,0,1,.92-.12h0ZM36.51,190.58l-4,3.72a2.42,2.42,0,0,0-.63,1.16l4.85,2.79a2.45,2.45,0,0,1,.64-1.15l4-3.71Zm30.63-35.27a.88.88,0,0,0-.33-.13l-3.08-.69a1.67,1.67,0,0,0-1.74.81l-2.9,5.51a2.53,2.53,0,0,1-.65.75l4.86,2.8a2.62,2.62,0,0,0,.65-.74l2.9-5.52a1.68,1.68,0,0,1,1.74-.81l3.08.69a1.52,1.52,0,0,1,.32.12Zm6.2,7.42h0a.81.81,0,0,0-.85.07L70.74,164l-.39,1a2,2,0,0,0,.48,1.95,6.82,6.82,0,0,1,.79,1c.07.09.14.16.21.24l.19.13a.9.9,0,0,0,.41.16,1.1,1.1,0,0,0,.54,0,.77.77,0,0,0,.29-.14l4.09-2.68a1.25,1.25,0,0,1,.31-.15.66.66,0,0,1,.34,0,.6.6,0,0,1,.19.06Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.54,173.93a2,2,0,0,1-.84.19l-3-.15a1.89,1.89,0,0,0-1.23.45l4.86,2.8a2,2,0,0,1,1.23-.45l3,.15a2,2,0,0,0,.85-.16Zm10-15.83a.79.79,0,0,0-.91.12L47,161.85a2.59,2.59,0,0,0-.76,1.21l4.86,2.8a2.52,2.52,0,0,1,.76-1.21L56.5,161a.81.81,0,0,1,.92-.12h0ZM36.51,190.58l-4,3.72a2.42,2.42,0,0,0-.63,1.16l4.85,2.79a2.45,2.45,0,0,1,.64-1.15l4-3.71Zm30.63-35.27a.88.88,0,0,0-.33-.13l-3.08-.69a1.67,1.67,0,0,0-1.74.81l-2.9,5.51a2.53,2.53,0,0,1-.65.75l4.86,2.8a2.62,2.62,0,0,0,.65-.74l2.9-5.52a1.68,1.68,0,0,1,1.74-.81l3.08.69a1.52,1.52,0,0,1,.32.12Zm6.2,7.42h0a.81.81,0,0,0-.85.07L70.74,164l-.39,1a2,2,0,0,0,.48,1.95,6.82,6.82,0,0,1,.79,1c.07.09.14.16.21.24l.19.13a.9.9,0,0,0,.41.16,1.1,1.1,0,0,0,.54,0,.77.77,0,0,0,.29-.14l4.09-2.68a1.25,1.25,0,0,1,.31-.15.66.66,0,0,1,.34,0,.6.6,0,0,1,.19.06Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.34,170.61l-.77-4.46a.74.74,0,0,0-1.22-.53l-4.08,2.69a1.18,1.18,0,0,1-1.64-.37,8.6,8.6,0,0,0-.8-1,2,2,0,0,1-.48-1.95l2.09-5.64a1,1,0,0,0-.77-1.4l-3.08-.69a1.68,1.68,0,0,0-1.74.81L64,163.62a3.07,3.07,0,0,1-1.75,1.32,13.43,13.43,0,0,0-1.89.62,1.05,1.05,0,0,1-1.46-.66l-1-3.46a.77.77,0,0,0-1.3-.41l-4.62,3.63a2.57,2.57,0,0,0-.88,2l.28,4.39a3.48,3.48,0,0,1-.72,2.12c-.75.91-1.47,1.86-2.14,2.84a2.4,2.4,0,0,1-1.88.95l-3-.15a1.92,1.92,0,0,0-1.7,1l-2.79,6.25a1.2,1.2,0,0,0,.62,1.59l2.4,1a1.48,1.48,0,0,1,.82,1.65,26.93,26.93,0,0,0-.51,3,3.76,3.76,0,0,1-1,2l-4.09,3.76a2.51,2.51,0,0,0-.69,2l.77,4.46a.73.73,0,0,0,1.22.52l4.08-2.69a1.2,1.2,0,0,1,1.64.37,8.73,8.73,0,0,0,.8,1,2,2,0,0,1,.48,2l-2.08,5.63a1,1,0,0,0,.76,1.4l3.08.69a1.65,1.65,0,0,0,1.74-.81L52,206.1a3,3,0,0,1,1.75-1.31,15.63,15.63,0,0,0,1.9-.63,1,1,0,0,1,1.45.67l1,3.45a.78.78,0,0,0,1.31.42l4.61-3.63a2.59,2.59,0,0,0,.88-2l-.28-4.39a3.51,3.51,0,0,1,.72-2.13,35,35,0,0,0,2.14-2.83,2.38,2.38,0,0,1,1.88-1l3,.15a1.89,1.89,0,0,0,1.7-1l2.79-6.25a1.18,1.18,0,0,0-.62-1.58l-2.4-1a1.5,1.5,0,0,1-.82-1.66,26.53,26.53,0,0,0,.51-3,3.83,3.83,0,0,1,1-2l4.09-3.76A2.45,2.45,0,0,0,79.34,170.61ZM59.63,194.38c-5,3.93-9.79,2.86-10.7-2.4s2.42-12.7,7.42-16.63,9.79-2.86,10.7,2.39S64.63,190.44,59.63,194.38Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.34,170.61l-.77-4.46a.74.74,0,0,0-1.22-.53l-4.08,2.69a1.18,1.18,0,0,1-1.64-.37,8.6,8.6,0,0,0-.8-1,2,2,0,0,1-.48-1.95l2.09-5.64a1,1,0,0,0-.77-1.4l-3.08-.69a1.68,1.68,0,0,0-1.74.81L64,163.62a3.07,3.07,0,0,1-1.75,1.32,13.43,13.43,0,0,0-1.89.62,1.05,1.05,0,0,1-1.46-.66l-1-3.46a.77.77,0,0,0-1.3-.41l-4.62,3.63a2.57,2.57,0,0,0-.88,2l.28,4.39a3.48,3.48,0,0,1-.72,2.12c-.75.91-1.47,1.86-2.14,2.84a2.4,2.4,0,0,1-1.88.95l-3-.15a1.92,1.92,0,0,0-1.7,1l-2.79,6.25a1.2,1.2,0,0,0,.62,1.59l2.4,1a1.48,1.48,0,0,1,.82,1.65,26.93,26.93,0,0,0-.51,3,3.76,3.76,0,0,1-1,2l-4.09,3.76a2.51,2.51,0,0,0-.69,2l.77,4.46a.73.73,0,0,0,1.22.52l4.08-2.69a1.2,1.2,0,0,1,1.64.37,8.73,8.73,0,0,0,.8,1,2,2,0,0,1,.48,2l-2.08,5.63a1,1,0,0,0,.76,1.4l3.08.69a1.65,1.65,0,0,0,1.74-.81L52,206.1a3,3,0,0,1,1.75-1.31,15.63,15.63,0,0,0,1.9-.63,1,1,0,0,1,1.45.67l1,3.45a.78.78,0,0,0,1.31.42l4.61-3.63a2.59,2.59,0,0,0,.88-2l-.28-4.39a3.51,3.51,0,0,1,.72-2.13,35,35,0,0,0,2.14-2.83,2.38,2.38,0,0,1,1.88-1l3,.15a1.89,1.89,0,0,0,1.7-1l2.79-6.25a1.18,1.18,0,0,0-.62-1.58l-2.4-1a1.5,1.5,0,0,1-.82-1.66,26.53,26.53,0,0,0,.51-3,3.83,3.83,0,0,1,1-2l4.09-3.76A2.45,2.45,0,0,0,79.34,170.61ZM59.63,194.38c-5,3.93-9.79,2.86-10.7-2.4s2.42-12.7,7.42-16.63,9.79-2.86,10.7,2.39S64.63,190.44,59.63,194.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.29,157.94h.16l3.08.69a.39.39,0,0,1,.26.18.38.38,0,0,1,0,.33l-2.08,5.63a2.69,2.69,0,0,0,.62,2.65,8,8,0,0,1,.73.9,2,2,0,0,0,1.58.85,1.85,1.85,0,0,0,1-.3l4.09-2.69c.07-.05.12-.06.12-.08a.39.39,0,0,1,.05.15l.77,4.46a1.82,1.82,0,0,1-.47,1.41l-4.09,3.76a4.38,4.38,0,0,0-1.22,2.44,25.69,25.69,0,0,1-.5,2.91,2.17,2.17,0,0,0,1.22,2.43l2.4,1a.55.55,0,0,1,.27.29.48.48,0,0,1,0,.39l-2.79,6.26a1.24,1.24,0,0,1-1,.64h0l-3-.14h-.1A3.08,3.08,0,0,0,67,193.37c-.66,1-1.37,1.91-2.1,2.79a4.08,4.08,0,0,0-.87,2.6l.27,4.39a1.89,1.89,0,0,1-.62,1.38l-4.61,3.63a.36.36,0,0,1-.16.08.3.3,0,0,1-.08-.15l-1-3.46a1.7,1.7,0,0,0-1.65-1.24,2,2,0,0,0-.71.14,13.69,13.69,0,0,1-1.81.6,3.72,3.72,0,0,0-2.18,1.66l-2.9,5.52a1,1,0,0,1-.84.48l-.16,0-3.07-.69a.35.35,0,0,1-.28-.5l2.08-5.64a2.7,2.7,0,0,0-.62-2.65,7.06,7.06,0,0,1-.73-.89,1.91,1.91,0,0,0-1.57-.85,1.8,1.8,0,0,0-1,.3l-4.08,2.69c-.08.05-.13.06-.13.07a.39.39,0,0,1-.05-.15L37.31,199a1.78,1.78,0,0,1,.48-1.4l4.09-3.76a4.46,4.46,0,0,0,1.21-2.45,29.09,29.09,0,0,1,.5-2.91,2.16,2.16,0,0,0-1.22-2.42L40,185a.48.48,0,0,1-.28-.28.51.51,0,0,1,0-.4l2.79-6.25a1.24,1.24,0,0,1,1-.65h0l3,.15h.1A3.09,3.09,0,0,0,49,176.35c.66-1,1.37-1.91,2.1-2.78A4.18,4.18,0,0,0,52,171l-.28-4.39a1.93,1.93,0,0,1,.62-1.38l4.62-3.63a.43.43,0,0,1,.15-.08.34.34,0,0,1,.08.16l1,3.45a1.7,1.7,0,0,0,1.65,1.24,2,2,0,0,0,.71-.14,13.69,13.69,0,0,1,1.81-.6,3.68,3.68,0,0,0,2.18-1.66l2.9-5.51a1,1,0,0,1,.84-.48M53.88,197.42a10.34,10.34,0,0,0,6.17-2.51c5.17-4.07,8.61-11.82,7.67-17.28-.58-3.34-2.68-5.33-5.62-5.33a10.3,10.3,0,0,0-6.17,2.52c-5.17,4.06-8.61,11.81-7.66,17.28.57,3.33,2.67,5.32,5.61,5.32m14.41-40.16a1.69,1.69,0,0,0-1.44.84L64,163.62a3.07,3.07,0,0,1-1.75,1.32,13.43,13.43,0,0,0-1.89.62,1.29,1.29,0,0,1-.46.09,1,1,0,0,1-1-.75l-1-3.46a.78.78,0,0,0-.73-.63.91.91,0,0,0-.57.22l-4.62,3.63a2.57,2.57,0,0,0-.88,2l.28,4.39a3.48,3.48,0,0,1-.72,2.12c-.75.91-1.47,1.86-2.14,2.84a2.42,2.42,0,0,1-1.81.95h-.07l-3-.15h-.06a1.91,1.91,0,0,0-1.64,1l-2.79,6.25a1.2,1.2,0,0,0,.62,1.59l2.4,1a1.48,1.48,0,0,1,.82,1.65,26.93,26.93,0,0,0-.51,3,3.76,3.76,0,0,1-1,2l-4.09,3.76a2.51,2.51,0,0,0-.69,2l.77,4.46c.08.44.35.7.7.7a1,1,0,0,0,.52-.18l4.08-2.69a1.22,1.22,0,0,1,.63-.19,1.26,1.26,0,0,1,1,.56,8.73,8.73,0,0,0,.8,1,2,2,0,0,1,.48,2l-2.08,5.63a1,1,0,0,0,.76,1.4l3.08.69a1.45,1.45,0,0,0,.3,0,1.66,1.66,0,0,0,1.44-.84L52,206.1a3,3,0,0,1,1.75-1.31,15.63,15.63,0,0,0,1.9-.63,1.2,1.2,0,0,1,.45-.09,1,1,0,0,1,1,.76l1,3.45a.8.8,0,0,0,.73.64.94.94,0,0,0,.58-.22l4.61-3.63a2.59,2.59,0,0,0,.88-2l-.28-4.39a3.51,3.51,0,0,1,.72-2.13,35,35,0,0,0,2.14-2.83,2.4,2.4,0,0,1,1.81-1h.07l3,.15h.07a1.9,1.9,0,0,0,1.63-1l2.79-6.25a1.18,1.18,0,0,0-.62-1.58l-2.4-1a1.5,1.5,0,0,1-.82-1.66,26.53,26.53,0,0,0,.51-3,3.83,3.83,0,0,1,1-2l4.09-3.76a2.45,2.45,0,0,0,.69-2l-.77-4.46c-.08-.45-.35-.7-.7-.7a.94.94,0,0,0-.52.17l-4.08,2.69a1.12,1.12,0,0,1-.62.19,1.25,1.25,0,0,1-1-.56,8.6,8.6,0,0,0-.8-1,2,2,0,0,1-.48-1.95l2.09-5.64a1,1,0,0,0-.77-1.4l-3.08-.69a1.39,1.39,0,0,0-.3,0ZM53.88,196.75c-2.5,0-4.41-1.65-5-4.77-.9-5.25,2.42-12.7,7.42-16.63A9.67,9.67,0,0,1,62.1,173c2.51,0,4.41,1.64,4.95,4.76.9,5.26-2.42,12.7-7.42,16.64a9.69,9.69,0,0,1-5.75,2.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.58,191.77a1.41,1.41,0,0,1-1.16.66l-3-.15a2.91,2.91,0,0,0-2.34,1.18c-.67,1-1.38,1.92-2.11,2.8a2.83,2.83,0,0,0-.3.42,4,4,0,0,0-.54,2.07l.27,4.39a2,2,0,0,1-.29,1,1.75,1.75,0,0,1-.38.48l-4.62,3.62a.37.37,0,0,1-.29.11c-.08,0-.14-.12-.19-.26l-1-3.45a1.55,1.55,0,0,0-.82-1,1.58,1.58,0,0,0-1.33,0,13.47,13.47,0,0,1-1.83.6,3.54,3.54,0,0,0-2,1.51l0,.07-2.89,5.52h0a1.16,1.16,0,0,1-1.17.54l-3.08-.69a.55.55,0,0,1-.36-.26.5.5,0,0,1,0-.45l2.08-5.63a2.54,2.54,0,0,0-.59-2.49,7.51,7.51,0,0,1-.75-.92,1.69,1.69,0,0,0-2.35-.5l-4.09,2.69c-.14.08-.23.09-.28.07s-.11-.09-.13-.25L37.16,199a2,2,0,0,1,.26-1.21,1.52,1.52,0,0,1,.26-.33l4.09-3.76a3.52,3.52,0,0,0,.62-.8,4.44,4.44,0,0,0,.55-1.56,29.27,29.27,0,0,1,.5-2.92,2,2,0,0,0-1.13-2.25l-2.39-1a.64.64,0,0,1-.36-.36.63.63,0,0,1,0-.52L42.36,178l0-.08a1.4,1.4,0,0,1,1.16-.65l3,.14a2.85,2.85,0,0,0,2.34-1.18c.67-1,1.38-1.91,2.11-2.79a2.74,2.74,0,0,0,.3-.43,4,4,0,0,0,.54-2.07l-.27-4.39a2,2,0,0,1,.29-1,1.69,1.69,0,0,1,.38-.47l4.62-3.63a.35.35,0,0,1,.29-.1.35.35,0,0,1,.19.25l1,3.46a1.55,1.55,0,0,0,.82,1,1.66,1.66,0,0,0,1.33,0,15.7,15.7,0,0,1,1.83-.61,3.58,3.58,0,0,0,2-1.5l0-.08,2.89-5.52h0a1.18,1.18,0,0,1,1.17-.54l3.08.69a.5.5,0,0,1,.38.71l-2.08,5.64a2.54,2.54,0,0,0,.59,2.49,7.41,7.41,0,0,1,.75.91,1.71,1.71,0,0,0,2.36.51l4.08-2.69c.14-.09.23-.1.28-.08s.11.1.14.26l.76,4.46a1.92,1.92,0,0,1-.26,1.2,1.6,1.6,0,0,1-.26.34L74.21,176a3.52,3.52,0,0,0-.62.8,4.39,4.39,0,0,0-.55,1.55,24.61,24.61,0,0,1-.5,2.93,2,2,0,0,0,1.13,2.25l2.4,1a.69.69,0,0,1,.36.37.67.67,0,0,1,0,.52l-2.79,6.25,0,.08M51,180.83c-2.19,3.81-3.17,8-2.61,11.24a5.89,5.89,0,0,0,3.49,4.85c2.28.87,5.21.1,8-2.13a20.6,20.6,0,0,0,5-5.9c2.19-3.8,3.17-8,2.61-11.24a5.86,5.86,0,0,0-3.49-4.84c-2.27-.88-5.21-.1-8,2.13a20.69,20.69,0,0,0-5,5.89M74,192l.06-.13,2.79-6.25a1.18,1.18,0,0,0-.62-1.58l-2.4-1a1.5,1.5,0,0,1-.82-1.66,26.53,26.53,0,0,0,.51-3,3.82,3.82,0,0,1,.49-1.35,3.35,3.35,0,0,1,.51-.68l4.09-3.76a1.78,1.78,0,0,0,.36-.45,2.52,2.52,0,0,0,.33-1.56l-.77-4.46a.74.74,0,0,0-1.22-.53l-4.08,2.69a1.18,1.18,0,0,1-1.64-.37,7.65,7.65,0,0,0-.8-1,2,2,0,0,1-.48-1.95l2.09-5.64a1,1,0,0,0-.77-1.4l-3.08-.69a1.68,1.68,0,0,0-1.72.77l0,0L64,163.62l0,.06a3.08,3.08,0,0,1-1.72,1.26,13.43,13.43,0,0,0-1.89.62,1.05,1.05,0,0,1-1.46-.66l-1-3.46a.77.77,0,0,0-1.3-.41l-4.62,3.63a2.14,2.14,0,0,0-.52.62,2.6,2.6,0,0,0-.36,1.34l.28,4.39a3.47,3.47,0,0,1-.48,1.77,1.8,1.8,0,0,1-.24.35c-.75.91-1.47,1.86-2.14,2.84a2.4,2.4,0,0,1-1.88.95l-3-.15a1.9,1.9,0,0,0-1.63.92.83.83,0,0,0-.07.13l-2.79,6.25a1.2,1.2,0,0,0,.62,1.59l2.4,1a1.48,1.48,0,0,1,.82,1.65,26.93,26.93,0,0,0-.51,3,3.73,3.73,0,0,1-.48,1.35,3.19,3.19,0,0,1-.52.68l-4.09,3.76a1.67,1.67,0,0,0-.36.46,2.52,2.52,0,0,0-.33,1.56l.77,4.46a.73.73,0,0,0,1.22.52l4.08-2.69a1.2,1.2,0,0,1,1.64.37,8.73,8.73,0,0,0,.8,1,2,2,0,0,1,.48,2l-2.08,5.63a1,1,0,0,0,.76,1.4l3.08.69a1.69,1.69,0,0,0,1.72-.76l0,0,2.9-5.51,0-.06a3.08,3.08,0,0,1,1.72-1.26,15.63,15.63,0,0,0,1.9-.63,1,1,0,0,1,1.45.67l1,3.45a.78.78,0,0,0,1.31.42l4.61-3.63a2.45,2.45,0,0,0,.52-.62,2.6,2.6,0,0,0,.36-1.34l-.28-4.39a3.42,3.42,0,0,1,.48-1.77,1.88,1.88,0,0,1,.24-.36,35,35,0,0,0,2.14-2.83,2.38,2.38,0,0,1,1.88-1l3,.15A1.93,1.93,0,0,0,74,192ZM51.49,181.1a20.28,20.28,0,0,1,4.86-5.75c5-3.93,9.79-2.86,10.7,2.39.56,3.24-.49,7.32-2.56,10.89a20.28,20.28,0,0,1-4.86,5.75c-5,3.93-9.79,2.86-10.7-2.4-.55-3.24.5-7.31,2.56-10.88Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.89,238.37h0l-5.54-3.18h0a.63.63,0,0,0-.57,0L76,236.91a1.74,1.74,0,0,1,.11-.92l4.37-8.81a1,1,0,0,0-.39-1.28l-4.74-2.74h0L69.82,220a1,1,0,0,0-1.3.31l-5.45,8.18a1.66,1.66,0,0,1-.71.55l-.42-4.15a.64.64,0,0,0-.28-.5h0l-5.55-3.18h0a.58.58,0,0,0-.59.05l-7.36,4.25a2,2,0,0,0-.88,1.37l-.74,8.19a2.69,2.69,0,0,1-.76,1.53,43.23,43.23,0,0,0-4.09,4.33,1.41,1.41,0,0,1-1.45.41l-4.72-1.65a1.15,1.15,0,0,0-1.33.49l-5.41,9.37a1.16,1.16,0,0,0,.24,1.4l3.79,3.27a1.42,1.42,0,0,1,.37,1.45,44.2,44.2,0,0,0-1.71,5.71,2.75,2.75,0,0,1-.94,1.43l-6.72,4.73a2,2,0,0,0-.75,1.45v8.49a.59.59,0,0,0,.26.55h0l5.54,3.18h0a.63.63,0,0,0,.57,0l3.78-1.7a1.72,1.72,0,0,1-.11.91l-4.37,8.81a1,1,0,0,0,.39,1.28l6.65,3.82h0l3.61,2.08a1,1,0,0,0,1.3-.3l5.44-8.19a1.76,1.76,0,0,1,.72-.55l.42,4.15a.59.59,0,0,0,.28.5h0l5.54,3.17h0a.6.6,0,0,0,.6-.05l7.36-4.25a2,2,0,0,0,.88-1.37l.74-8.19a2.69,2.69,0,0,1,.76-1.53,44.41,44.41,0,0,0,4.09-4.33,1.41,1.41,0,0,1,1.45-.41l4.72,1.65a1.15,1.15,0,0,0,1.33-.49l5.41-9.37a1.16,1.16,0,0,0-.24-1.4l-3.79-3.26a1.44,1.44,0,0,1-.37-1.46A44.2,44.2,0,0,0,77.74,255a2.69,2.69,0,0,1,.94-1.42l6.72-4.74a2,2,0,0,0,.75-1.44v-8.5A.6.6,0,0,0,85.89,238.37ZM44.94,267c0-7.93,5.56-17.57,12.43-21.53,2.69-1.56,5.17-2,7.2-1.51a11.38,11.38,0,0,1,1.62,6.6c0,7.93-5.57,17.57-12.44,21.53-2.68,1.55-5,2.06-6.76,1.63A10.17,10.17,0,0,1,44.94,267Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.89,238.37h0l-5.54-3.18h0a.63.63,0,0,0-.57,0L76,236.91a1.74,1.74,0,0,1,.11-.92l4.37-8.81a1,1,0,0,0-.39-1.28l-4.74-2.74h0L69.82,220a1,1,0,0,0-1.3.31l-5.45,8.18a1.66,1.66,0,0,1-.71.55l-.42-4.15a.64.64,0,0,0-.28-.5h0l-5.55-3.18h0a.58.58,0,0,0-.59.05l-7.36,4.25a2,2,0,0,0-.88,1.37l-.74,8.19a2.69,2.69,0,0,1-.76,1.53,43.23,43.23,0,0,0-4.09,4.33,1.41,1.41,0,0,1-1.45.41l-4.72-1.65a1.15,1.15,0,0,0-1.33.49l-5.41,9.37a1.16,1.16,0,0,0,.24,1.4l3.79,3.27a1.42,1.42,0,0,1,.37,1.45,44.2,44.2,0,0,0-1.71,5.71,2.75,2.75,0,0,1-.94,1.43l-6.72,4.73a2,2,0,0,0-.75,1.45v8.49a.59.59,0,0,0,.26.55h0l5.54,3.18h0a.63.63,0,0,0,.57,0l3.78-1.7a1.72,1.72,0,0,1-.11.91l-4.37,8.81a1,1,0,0,0,.39,1.28l6.65,3.82h0l3.61,2.08a1,1,0,0,0,1.3-.3l5.44-8.19a1.76,1.76,0,0,1,.72-.55l.42,4.15a.59.59,0,0,0,.28.5h0l5.54,3.17h0a.6.6,0,0,0,.6-.05l7.36-4.25a2,2,0,0,0,.88-1.37l.74-8.19a2.69,2.69,0,0,1,.76-1.53,44.41,44.41,0,0,0,4.09-4.33,1.41,1.41,0,0,1,1.45-.41l4.72,1.65a1.15,1.15,0,0,0,1.33-.49l5.41-9.37a1.16,1.16,0,0,0-.24-1.4l-3.79-3.26a1.44,1.44,0,0,1-.37-1.46A44.2,44.2,0,0,0,77.74,255a2.69,2.69,0,0,1,.94-1.42l6.72-4.74a2,2,0,0,0,.75-1.44v-8.5A.6.6,0,0,0,85.89,238.37ZM44.94,267c0-7.93,5.56-17.57,12.43-21.53,2.69-1.56,5.17-2,7.2-1.51a11.38,11.38,0,0,1,1.62,6.6c0,7.93-5.57,17.57-12.44,21.53-2.68,1.55-5,2.06-6.76,1.63A10.17,10.17,0,0,1,44.94,267Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.07,278.74a.78.78,0,0,0-1.09-.5l-2.76,1.24a1.66,1.66,0,0,1-.12.92l-4.37,8.81a1,1,0,0,0,.39,1.28l6.65,3.82-1.12-.65a1,1,0,0,1-.39-1.27l4.37-8.81a1.82,1.82,0,0,0-.1-1.59A14.43,14.43,0,0,1,37.07,278.74Zm16,16.42a.77.77,0,0,1-.22-.47l-.71-7.15a.78.78,0,0,0-1-.69,15.25,15.25,0,0,1-3.54.36,1.65,1.65,0,0,0-.71.15l.42,4.15a.61.61,0,0,0,.28.5h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8,252.6c0,7.93-5.56,17.58-12.43,21.54-4.34,2.51-8.16,2.15-10.38-.46,1.78.43,4.07-.07,6.76-1.63,6.87-4,12.43-13.6,12.43-21.53,0-2.91-.55-5.13-1.6-6.6C67.74,244.7,69.8,247.78,69.8,252.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.82,220a1,1,0,0,0-1.3.31l-5.45,8.18a1.5,1.5,0,0,1-.36.35L68.25,232a1.37,1.37,0,0,0,.36-.36l5.44-8.18a1,1,0,0,1,1.19-.36Zm10.53,15.19h0a.6.6,0,0,0-.57,0L76,236.91a1.84,1.84,0,0,0,.23.66,14.94,14.94,0,0,1,1.4,3.1l.06.15a.81.81,0,0,0,.19.34l.09.09a.94.94,0,0,0,.22.12.8.8,0,0,0,.41,0,.76.76,0,0,0,.18-.06l6.55-3a.44.44,0,0,1,.16-.06.45.45,0,0,1,.23,0,.36.36,0,0,1,.18.07h0Zm-24.24-14a.61.61,0,0,0-.59.06l-7.36,4.25a1.88,1.88,0,0,0-.74.89L53,229.56a1.9,1.9,0,0,1,.74-.88l7.36-4.26a.64.64,0,0,1,.56-.07ZM31.05,262.25a2.5,2.5,0,0,1-.52.55l-6.72,4.73a1.87,1.87,0,0,0-.45.51l5.53,3.17a1.61,1.61,0,0,1,.45-.51L36.07,266a2.3,2.3,0,0,0,.52-.55Zm4.08-22.62a1.14,1.14,0,0,0-.94.54l-5.41,9.37a1.1,1.1,0,0,0-.12.69l5.53,3.18a1.1,1.1,0,0,1,.12-.69l5.42-9.37a1.12,1.12,0,0,1,.87-.55Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.82,220a1,1,0,0,0-1.3.31l-5.45,8.18a1.5,1.5,0,0,1-.36.35L68.25,232a1.37,1.37,0,0,0,.36-.36l5.44-8.18a1,1,0,0,1,1.19-.36Zm10.53,15.19h0a.6.6,0,0,0-.57,0L76,236.91a1.84,1.84,0,0,0,.23.66,14.94,14.94,0,0,1,1.4,3.1l.06.15a.81.81,0,0,0,.19.34l.09.09a.94.94,0,0,0,.22.12.8.8,0,0,0,.41,0,.76.76,0,0,0,.18-.06l6.55-3a.44.44,0,0,1,.16-.06.45.45,0,0,1,.23,0,.36.36,0,0,1,.18.07h0Zm-24.24-14a.61.61,0,0,0-.59.06l-7.36,4.25a1.88,1.88,0,0,0-.74.89L53,229.56a1.9,1.9,0,0,1,.74-.88l7.36-4.26a.64.64,0,0,1,.56-.07ZM31.05,262.25a2.5,2.5,0,0,1-.52.55l-6.72,4.73a1.87,1.87,0,0,0-.45.51l5.53,3.17a1.61,1.61,0,0,1,.45-.51L36.07,266a2.3,2.3,0,0,0,.52-.55Zm4.08-22.62a1.14,1.14,0,0,0-.94.54l-5.41,9.37a1.1,1.1,0,0,0-.12.69l5.53,3.18a1.1,1.1,0,0,1,.12-.69l5.42-9.37a1.12,1.12,0,0,1,.87-.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.15,247.42v-8.5a.54.54,0,0,0-.83-.54l-6.56,3a.78.78,0,0,1-1.09-.51,14.85,14.85,0,0,0-1.46-3.25,1.83,1.83,0,0,1-.1-1.58l4.37-8.81a1,1,0,0,0-.39-1.28l-4.74-2.74a1,1,0,0,0-1.3.31l-5.44,8.18a1.78,1.78,0,0,1-1.43.71,14.73,14.73,0,0,0-3.54.36.77.77,0,0,1-1-.69l-.72-7.15a.55.55,0,0,0-.89-.46l-7.36,4.25a2,2,0,0,0-.88,1.38l-.73,8.19a2.83,2.83,0,0,1-.77,1.53,45.45,45.45,0,0,0-4.09,4.32,1.37,1.37,0,0,1-1.44.41l-4.73-1.65a1.15,1.15,0,0,0-1.32.5l-5.42,9.37a1.16,1.16,0,0,0,.24,1.39l3.79,3.27a1.39,1.39,0,0,1,.37,1.46,43.54,43.54,0,0,0-1.7,5.7,2.74,2.74,0,0,1-.94,1.43l-6.73,4.73a2,2,0,0,0-.75,1.45v8.5a.55.55,0,0,0,.84.54L36,278.24a.78.78,0,0,1,1.09.5A14.43,14.43,0,0,0,38.53,282a1.85,1.85,0,0,1,.1,1.59l-4.37,8.8a1,1,0,0,0,.39,1.29l4.74,2.73a1,1,0,0,0,1.3-.3l5.44-8.19a1.85,1.85,0,0,1,1.43-.71,14.19,14.19,0,0,0,3.54-.36.79.79,0,0,1,1,.7l.71,7.15a.55.55,0,0,0,.89.45l7.36-4.25a2,2,0,0,0,.88-1.37l.74-8.19a2.69,2.69,0,0,1,.76-1.53,44.41,44.41,0,0,0,4.09-4.33,1.41,1.41,0,0,1,1.45-.41l4.72,1.65a1.15,1.15,0,0,0,1.33-.49l5.41-9.37a1.16,1.16,0,0,0-.24-1.4l-3.79-3.26a1.44,1.44,0,0,1-.37-1.46A44.2,44.2,0,0,0,77.74,255a2.69,2.69,0,0,1,.94-1.42l6.72-4.74A2,2,0,0,0,86.15,247.42ZM57.37,274.14c-6.87,4-12.43.75-12.43-7.18s5.56-17.57,12.43-21.53,12.44-.76,12.44,7.17S64.24,270.18,57.37,274.14Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.15,247.42v-8.5a.54.54,0,0,0-.83-.54l-6.56,3a.78.78,0,0,1-1.09-.51,14.85,14.85,0,0,0-1.46-3.25,1.83,1.83,0,0,1-.1-1.58l4.37-8.81a1,1,0,0,0-.39-1.28l-4.74-2.74a1,1,0,0,0-1.3.31l-5.44,8.18a1.78,1.78,0,0,1-1.43.71,14.73,14.73,0,0,0-3.54.36.77.77,0,0,1-1-.69l-.72-7.15a.55.55,0,0,0-.89-.46l-7.36,4.25a2,2,0,0,0-.88,1.38l-.73,8.19a2.83,2.83,0,0,1-.77,1.53,45.45,45.45,0,0,0-4.09,4.32,1.37,1.37,0,0,1-1.44.41l-4.73-1.65a1.15,1.15,0,0,0-1.32.5l-5.42,9.37a1.16,1.16,0,0,0,.24,1.39l3.79,3.27a1.39,1.39,0,0,1,.37,1.46,43.54,43.54,0,0,0-1.7,5.7,2.74,2.74,0,0,1-.94,1.43l-6.73,4.73a2,2,0,0,0-.75,1.45v8.5a.55.55,0,0,0,.84.54L36,278.24a.78.78,0,0,1,1.09.5A14.43,14.43,0,0,0,38.53,282a1.85,1.85,0,0,1,.1,1.59l-4.37,8.8a1,1,0,0,0,.39,1.29l4.74,2.73a1,1,0,0,0,1.3-.3l5.44-8.19a1.85,1.85,0,0,1,1.43-.71,14.19,14.19,0,0,0,3.54-.36.79.79,0,0,1,1,.7l.71,7.15a.55.55,0,0,0,.89.45l7.36-4.25a2,2,0,0,0,.88-1.37l.74-8.19a2.69,2.69,0,0,1,.76-1.53,44.41,44.41,0,0,0,4.09-4.33,1.41,1.41,0,0,1,1.45-.41l4.72,1.65a1.15,1.15,0,0,0,1.33-.49l5.41-9.37a1.16,1.16,0,0,0-.24-1.4l-3.79-3.26a1.44,1.44,0,0,1-.37-1.46A44.2,44.2,0,0,0,77.74,255a2.69,2.69,0,0,1,.94-1.42l6.72-4.74A2,2,0,0,0,86.15,247.42ZM57.37,274.14c-6.87,4-12.43.75-12.43-7.18s5.56-17.57,12.43-21.53,12.44-.76,12.44,7.17S64.24,270.18,57.37,274.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.87,223.71a.34.34,0,0,1,.15,0l4.73,2.74a.3.3,0,0,1,.12.39l-4.36,8.81a2.44,2.44,0,0,0,.13,2.24A14.16,14.16,0,0,1,77,241a1.45,1.45,0,0,0,1.39,1.05A1.5,1.5,0,0,0,79,242l6.44-2.9v8.37a1.33,1.33,0,0,1-.47.89L78.29,253a3.38,3.38,0,0,0-1.21,1.83,45.2,45.2,0,0,1-1.68,5.62A2.08,2.08,0,0,0,76,262.7L79.75,266a.47.47,0,0,1,.09.54l-5.41,9.37a.49.49,0,0,1-.4.21l-.12,0-4.72-1.65a2,2,0,0,0-.61-.1A2.09,2.09,0,0,0,67,275a44.43,44.43,0,0,1-4,4.26,3.43,3.43,0,0,0-1,2l-.73,8.19a1.39,1.39,0,0,1-.55.85l-7.24,4.18-.71-7a1.45,1.45,0,0,0-1.45-1.33,2,2,0,0,0-.35,0,14.37,14.37,0,0,1-3.06.35h-.37a2.48,2.48,0,0,0-2,1l-5.44,8.18a.3.3,0,0,1-.26.13.27.27,0,0,1-.14,0L35,293.08a.32.32,0,0,1-.12-.4l4.37-8.8a2.5,2.5,0,0,0-.13-2.24,13.47,13.47,0,0,1-1.39-3.1,1.47,1.47,0,0,0-1.4-1.06,1.51,1.51,0,0,0-.62.14l-6.43,2.9v-8.37a1.32,1.32,0,0,1,.46-.89l6.72-4.74a3.39,3.39,0,0,0,1.22-1.83,43.48,43.48,0,0,1,1.67-5.62,2.06,2.06,0,0,0-.56-2.2L35,253.6a.49.49,0,0,1-.09-.54l5.41-9.37a.49.49,0,0,1,.4-.21h.12l4.72,1.65a1.77,1.77,0,0,0,.61.1,2.08,2.08,0,0,0,1.58-.71,44.57,44.57,0,0,1,4-4.27,3.4,3.4,0,0,0,1-2l.74-8.19a1.28,1.28,0,0,1,.54-.85l7.25-4.19.7,7a1.48,1.48,0,0,0,1.81,1.28,14.21,14.21,0,0,1,3.05-.35h.38a2.5,2.5,0,0,0,2-1l5.44-8.18a.31.31,0,0,1,.26-.14M51.82,276.52a12,12,0,0,0,5.89-1.79c7-4.07,12.77-14,12.77-22.13,0-5.8-3-9.55-7.56-9.55A11.88,11.88,0,0,0,57,244.84c-7,4.07-12.77,14-12.77,22.12,0,5.81,3,9.56,7.56,9.56M74.87,223a1,1,0,0,0-.82.43l-5.44,8.18a1.8,1.8,0,0,1-1.39.71h-.38a15.16,15.16,0,0,0-3.2.36.71.71,0,0,1-.2,0,.76.76,0,0,1-.78-.71l-.72-7.15c0-.36-.25-.56-.52-.56a.76.76,0,0,0-.37.1l-7.36,4.25a2,2,0,0,0-.88,1.38l-.73,8.19a2.83,2.83,0,0,1-.77,1.53,45.45,45.45,0,0,0-4.09,4.32,1.39,1.39,0,0,1-1.06.48,1,1,0,0,1-.38-.07l-4.73-1.65a1.27,1.27,0,0,0-.34,0,1.14,1.14,0,0,0-1,.55l-5.42,9.37a1.16,1.16,0,0,0,.24,1.39l3.79,3.27a1.39,1.39,0,0,1,.37,1.46,43.54,43.54,0,0,0-1.7,5.7,2.69,2.69,0,0,1-.95,1.43l-6.72,4.73a2,2,0,0,0-.75,1.45v8.5c0,.38.21.62.52.62a.83.83,0,0,0,.32-.08L36,278.24a.84.84,0,0,1,.34-.08.78.78,0,0,1,.75.58A14.43,14.43,0,0,0,38.53,282a1.85,1.85,0,0,1,.1,1.59l-4.37,8.8a1,1,0,0,0,.39,1.29l4.74,2.73a.91.91,0,0,0,.48.13,1,1,0,0,0,.82-.43l5.44-8.19a1.85,1.85,0,0,1,1.4-.71h.37a14.57,14.57,0,0,0,3.2-.37l.21,0a.77.77,0,0,1,.78.72l.71,7.15a.55.55,0,0,0,.53.56.68.68,0,0,0,.36-.11l7.36-4.25a2,2,0,0,0,.88-1.37l.74-8.19a2.69,2.69,0,0,1,.76-1.53,44.41,44.41,0,0,0,4.09-4.33,1.44,1.44,0,0,1,1.06-.47,1.23,1.23,0,0,1,.39.06l4.72,1.65a1,1,0,0,0,.34.06,1.17,1.17,0,0,0,1-.55l5.41-9.37a1.16,1.16,0,0,0-.24-1.4l-3.79-3.26a1.44,1.44,0,0,1-.37-1.46A44.2,44.2,0,0,0,77.74,255a2.69,2.69,0,0,1,.94-1.42l6.72-4.74a2,2,0,0,0,.75-1.44v-8.5c0-.39-.21-.62-.52-.62a.65.65,0,0,0-.31.08l-6.56,3a.84.84,0,0,1-.34.08.79.79,0,0,1-.75-.59,14.56,14.56,0,0,0-1.46-3.24,1.85,1.85,0,0,1-.1-1.59l4.37-8.81a1,1,0,0,0-.39-1.28l-4.74-2.74a1,1,0,0,0-.48-.12Zm-23.05,52.8c-4.08,0-6.88-3.25-6.88-8.88,0-7.93,5.56-17.57,12.43-21.53a11.21,11.21,0,0,1,5.55-1.7c4.09,0,6.89,3.25,6.89,8.87,0,7.93-5.57,17.58-12.44,21.54a11.28,11.28,0,0,1-5.55,1.7Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,266.58,74.56,276a.64.64,0,0,1-.7.26l-4.72-1.65a1.9,1.9,0,0,0-2,.57,44.65,44.65,0,0,1-4,4.27,2.77,2.77,0,0,0-.52.67,3.26,3.26,0,0,0-.42,1.2l-.73,8.19a1.26,1.26,0,0,1-.17.48,1.35,1.35,0,0,1-.45.49l-7.36,4.25-.09,0h0a.58.58,0,0,1,0-.1l-.72-7.15a1.33,1.33,0,0,0-.53-.94,1.38,1.38,0,0,0-1.09-.21,14,14,0,0,1-3.42.35,2.34,2.34,0,0,0-1.87.94l-5.44,8.19a.48.48,0,0,1-.61.14l-4.74-2.74a.46.46,0,0,1-.18-.59l4.37-8.81a2.37,2.37,0,0,0-.12-2.09,14.27,14.27,0,0,1-1.41-3.14,1.32,1.32,0,0,0-.73-.83,1.28,1.28,0,0,0-1.08,0l-6.55,2.95-.09,0h0a.55.55,0,0,1,0-.09v-8.5a1.43,1.43,0,0,1,.2-.63,1.32,1.32,0,0,1,.33-.39l6.73-4.73a3.05,3.05,0,0,0,.83-1,3.3,3.3,0,0,0,.32-.78A43.35,43.35,0,0,1,39.2,259a1.92,1.92,0,0,0-.52-2l-3.79-3.26a.64.64,0,0,1-.12-.74l5.41-9.37a.64.64,0,0,1,.7-.26L45.6,245a1.94,1.94,0,0,0,2-.57,42.4,42.4,0,0,1,4-4.28,3.11,3.11,0,0,0,.52-.67,3,3,0,0,0,.41-1.2l.74-8.19a1.21,1.21,0,0,1,.17-.48,1.38,1.38,0,0,1,.44-.48l7.36-4.25a.22.22,0,0,1,.1,0h0s0,0,0,.09l.72,7.15a1.27,1.27,0,0,0,.52.94,1.31,1.31,0,0,0,1.09.21,14.12,14.12,0,0,1,3.42-.34,2.34,2.34,0,0,0,1.87-.95l5.45-8.18a.46.46,0,0,1,.6-.14l4.74,2.73a.48.48,0,0,1,.18.6l-4.37,8.8a2.36,2.36,0,0,0,.13,2.1,14.17,14.17,0,0,1,1.4,3.13,1.36,1.36,0,0,0,.73.84,1.31,1.31,0,0,0,1.08,0l6.55-3,.1,0h0s0,0,0,.09v8.5a1.31,1.31,0,0,1-.2.63,1.26,1.26,0,0,1-.33.38l-6.72,4.74a3.12,3.12,0,0,0-.83,1,2.57,2.57,0,0,0-.32.79,46.07,46.07,0,0,1-1.69,5.64,1.92,1.92,0,0,0,.52,2l3.79,3.27a.64.64,0,0,1,.13.73h0M48.12,254.45A25.82,25.82,0,0,0,44.41,267c0,4,1.39,7.05,3.91,8.51s5.82,1.14,9.31-.88a25.8,25.8,0,0,0,9-9.47,25.82,25.82,0,0,0,3.71-12.52c0-4-1.39-7-3.9-8.5S60.6,243,57.11,245a25.84,25.84,0,0,0-9,9.48m32.31,12.4a1.16,1.16,0,0,0-.24-1.4l-3.79-3.26a1.44,1.44,0,0,1-.37-1.46A44.2,44.2,0,0,0,77.74,255a2.22,2.22,0,0,1,.26-.63,2.42,2.42,0,0,1,.68-.79l6.72-4.74a1.88,1.88,0,0,0,.49-.55,1.93,1.93,0,0,0,.26-.89v-8.5a.54.54,0,0,0-.83-.54l-6.56,3a.78.78,0,0,1-1.09-.51,14.85,14.85,0,0,0-1.46-3.25,1.83,1.83,0,0,1-.1-1.58l4.37-8.81a1,1,0,0,0-.39-1.28l-4.74-2.74a1,1,0,0,0-1.3.31l-5.44,8.18a1.78,1.78,0,0,1-1.43.71,14.73,14.73,0,0,0-3.54.36.77.77,0,0,1-1-.69l-.72-7.15a.55.55,0,0,0-.89-.46l-7.36,4.25a2,2,0,0,0-.64.68,1.77,1.77,0,0,0-.24.7l-.73,8.19a2.7,2.7,0,0,1-.35,1,2.42,2.42,0,0,1-.42.55,45.45,45.45,0,0,0-4.09,4.32,1.37,1.37,0,0,1-1.44.41l-4.73-1.65a1.15,1.15,0,0,0-1.32.5l-5.42,9.37a1.16,1.16,0,0,0,.24,1.39l3.79,3.27a1.39,1.39,0,0,1,.37,1.46,43.54,43.54,0,0,0-1.7,5.7,2.31,2.31,0,0,1-.27.64,2.52,2.52,0,0,1-.67.79l-6.73,4.73a1.78,1.78,0,0,0-.48.56,1.8,1.8,0,0,0-.27.89v8.5a.55.55,0,0,0,.84.54L36,278.24a.78.78,0,0,1,1.09.5A14.43,14.43,0,0,0,38.53,282a1.85,1.85,0,0,1,.1,1.59l-4.37,8.8a1,1,0,0,0,.39,1.29l4.74,2.73a1,1,0,0,0,1.3-.3l5.44-8.19a1.85,1.85,0,0,1,1.43-.71,14.19,14.19,0,0,0,3.54-.36.79.79,0,0,1,1,.7l.71,7.15a.55.55,0,0,0,.89.45l7.36-4.25a1.76,1.76,0,0,0,.64-.68,1.73,1.73,0,0,0,.24-.69l.74-8.19a2.45,2.45,0,0,1,.34-1,2.48,2.48,0,0,1,.42-.55,44.41,44.41,0,0,0,4.09-4.33,1.41,1.41,0,0,1,1.45-.41l4.72,1.65a1.15,1.15,0,0,0,1.33-.49l5.41-9.37ZM48.58,254.71a25.4,25.4,0,0,1,8.79-9.28c6.87-4,12.44-.76,12.44,7.17a27.52,27.52,0,0,1-12.44,21.54c-6.87,4-12.43.75-12.43-7.18a25.39,25.39,0,0,1,3.64-12.25Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Steps--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Requirements--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.78,336.57,57,352.34a1.78,1.78,0,0,0,1.59,0l71.53-41.29a1.69,1.69,0,0,0,.78-1.37v-2.8a1.74,1.74,0,0,0-.8-1.37l-27.25-15.77a1.76,1.76,0,0,0-1.58,0L29.76,331A1.78,1.78,0,0,0,29,332.4v2.8A1.76,1.76,0,0,0,29.78,336.57Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.13,305.51a1.78,1.78,0,0,1,.8,1.37v2.8a1.69,1.69,0,0,1-.78,1.37L58.62,352.34a1.61,1.61,0,0,1-.83.18l0-4.63a1.59,1.59,0,0,0,.79-.19l71.53-41.28C130.53,306.19,130.6,305.77,130.13,305.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.64,331.11c-.31.25-.27.6.12.83L57,347.7a1.57,1.57,0,0,0,.79.19l0,4.64a1.71,1.71,0,0,1-.76-.19L29.78,336.57a1.76,1.76,0,0,1-.8-1.37v-2.8A1.74,1.74,0,0,1,29.64,331.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.76,331.94,57,347.7a1.7,1.7,0,0,0,1.58,0l64-36.92,7.54-4.36a.48.48,0,0,0,0-.91l-27.25-15.77a1.76,1.76,0,0,0-1.58,0L29.76,331A.49.49,0,0,0,29.76,331.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.24,331.48l71.37-41.19a1.13,1.13,0,0,1,1,0L129.66,306l-7.39,4.27-64,36.92a1.13,1.13,0,0,1-1,0L30.24,331.48m-.75.21a.82.82,0,0,0,.27.25L57,347.7a1.7,1.7,0,0,0,1.58,0l64-36.92,7.54-4.36c.31-.18.4-.44.27-.66a.66.66,0,0,0-.27-.25l-27.25-15.77a1.76,1.76,0,0,0-1.58,0L29.76,331c-.31.18-.4.44-.27.67Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.37,330.84a4,4,0,0,1,4.33.21l.84.48c1.13.65,1.49,1.26,1,1.86a4.13,4.13,0,0,1,3.26.59l1.6.93a4.62,4.62,0,0,0,1.41.6l-1,.58a4.78,4.78,0,0,1-1.42-.62l-1.61-.93A2.56,2.56,0,0,0,53,334.4l-.7.41,4.39,2.53-1,.57L45.39,332ZM52,333.78c.79-.45,1-.9-.15-1.54l-1-.57a2.32,2.32,0,0,0-2.44-.22l-1,.56,3.8,2.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11,329.89l1,.59L57,331.74l3.65,2.11,2.67-1.54,1.05.6L60.67,335,50.4,329.09,54.06,327l1,.6-2.67,1.54,3.51,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.46,325.57l5.31,3.07A3,3,0,0,1,68,329.76a1.09,1.09,0,0,0,.87-.13l.13-.07,1,.58-.16.1a2.51,2.51,0,0,1-1.8.27,1.56,1.56,0,0,1-.77.8,4.6,4.6,0,0,1-4.62-.32l-5.31-3.07c-1.57-.9-1.91-1.88-.55-2.66A4.55,4.55,0,0,1,61.46,325.57Zm-3.16,1.75,5.43,3.14a2.51,2.51,0,0,0,2.54.25c.72-.42.51-.92-.43-1.47l-5.43-3.13a2.48,2.48,0,0,0-2.54-.25C57.16,326.27,57.37,326.79,58.3,327.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.88,327.49a2.47,2.47,0,0,0,2.52.25c.72-.41.48-.91-.45-1.45l-7.85-4.53.93-.54,7.79,4.5c1.56.9,2,1.86.6,2.65a4.51,4.51,0,0,1-4.58-.35l-7.79-4.5,1-.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,320.08,76.27,326l-1,.57L65,320.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,318.35a4,4,0,0,1,4.33.21l.83.48c1.14.66,1.5,1.26,1,1.86a4.15,4.15,0,0,1,3.27.6l1.6.92a4.79,4.79,0,0,0,1.41.61l-1,.58A5,5,0,0,1,79,323l-1.62-.93a2.54,2.54,0,0,0-2.82-.13l-.7.4,4.39,2.54-1,.57L67,319.5Zm4.59,2.94c.79-.45,1-.89-.15-1.54l-1-.56A2.27,2.27,0,0,0,70,319l-1,.56,3.8,2.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.74,317.4l1,.6-2.18,1.25,3.66,2.11,2.67-1.54,1,.6-3.66,2.12L72,316.6l3.66-2.11,1,.6-2.67,1.54,3.51,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.14,318l-1,.55-9.65-3.87,8.19,4.73-.87.5L76.59,314l1.38-.8,9.67,3.89-6.79-5.55,1.38-.8,10.28,5.93-.94.55-8.27-4.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,310.92l1,.6-2.17,1.25,3.65,2.11,2.67-1.54,1,.6-3.66,2.12-10.28-5.94L86.91,308l1,.6-2.67,1.54,3.51,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,312.91l-.89.51-10.28-5.93,1.26-.73,9.49,3.1-7.43-4.29.88-.5L102.29,311l-1,.59-10.59-3.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6,309.66l-9.23-5.33-1.64.95-1-.6L97,302.21l1,.6-1.64.95,9.23,5.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,301l.28.16-.94.55-.34-.2a2.44,2.44,0,0,0-2.49-.26c-.71.41-.47.9.44,1.43,2.3,1.33,5.51-.27,8.41,1.4,1.55.9,1.92,1.86.56,2.64a4.49,4.49,0,0,1-4.57-.33l-.59-.34.93-.53.65.37a2.45,2.45,0,0,0,2.51.25c.71-.41.5-.92-.43-1.45-2.29-1.32-5.48.27-8.37-1.4-1.59-.92-1.94-1.85-.6-2.63A4.53,4.53,0,0,1,104,301Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Design--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.62,366l27.25,15.77a1.78,1.78,0,0,0,1.59,0L181,340.5a1.69,1.69,0,0,0,.78-1.37v-2.8A1.74,1.74,0,0,0,181,335l-27.25-15.77a1.76,1.76,0,0,0-1.58,0L80.6,360.47a1.77,1.77,0,0,0-.78,1.37v2.81A1.76,1.76,0,0,0,80.62,366Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,335a1.78,1.78,0,0,1,.8,1.37v2.8a1.69,1.69,0,0,1-.78,1.37l-71.53,41.29a1.61,1.61,0,0,1-.83.18l0-4.63a1.59,1.59,0,0,0,.79-.19L181,335.87C181.37,335.64,181.44,335.22,181,335Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.48,360.55c-.31.26-.27.61.12.84l27.25,15.76a1.63,1.63,0,0,0,.8.19l0,4.64a1.71,1.71,0,0,1-.76-.19L80.62,366a1.74,1.74,0,0,1-.8-1.37v-2.8A1.78,1.78,0,0,1,80.48,360.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.6,361.39l27.26,15.76a1.76,1.76,0,0,0,1.58,0l64-36.92,7.54-4.36a.48.48,0,0,0,0-.91l-27.25-15.77a1.76,1.76,0,0,0-1.58,0L80.6,360.47A.49.49,0,0,0,80.6,361.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,360.93l71.37-41.19a1.13,1.13,0,0,1,1,0l27.1,15.67-7.39,4.27-64,36.92a1.13,1.13,0,0,1-1,0L81.08,360.93m-.75.21a.94.94,0,0,0,.27.25l27.26,15.76a1.76,1.76,0,0,0,1.58,0l64-36.92,7.54-4.36c.31-.18.4-.44.27-.66A.66.66,0,0,0,181,335l-27.25-15.77a1.76,1.76,0,0,0-1.58,0L80.6,360.47c-.31.18-.4.44-.27.67Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.27,351.59a4.43,4.43,0,0,1,4.58.31l5.18,3c1.57.91,1.91,1.83.52,2.63l-2.08,1.21-10.28-5.94Zm9.23,5.34c.71-.41.54-.91-.4-1.45l-5.29-3.05a2.43,2.43,0,0,0-2.52-.22l-1.06.61,8.19,4.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.94,350.69l1,.59-2.17,1.26,3.65,2.11,2.67-1.55,1,.61-3.66,2.11-10.27-5.93,3.66-2.12,1,.61-2.67,1.54,3.51,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.12,346.45l.28.16-.94.54-.34-.2a2.42,2.42,0,0,0-2.48-.26c-.72.41-.48.91.43,1.43,2.31,1.33,5.52-.27,8.41,1.4,1.55.9,1.92,1.86.56,2.65a4.54,4.54,0,0,1-4.57-.33l-.58-.34.92-.54.65.37a2.45,2.45,0,0,0,2.51.25c.71-.41.5-.92-.43-1.45-2.28-1.32-5.48.27-8.37-1.4-1.59-.92-1.94-1.85-.6-2.62A4.48,4.48,0,0,1,128.12,346.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.52,343.94l10.28,5.94-1,.57-10.28-5.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,342.52l.88.51-.94.54L134,343a2.49,2.49,0,0,0-2.53-.26c-.71.42-.48.93.45,1.46l5.43,3.14a2.49,2.49,0,0,0,2.52.25c.73-.42.49-.92-.44-1.45l-2-1.19-.92.53-1-.6,1.86-1.07,3,1.75c1.56.9,2,1.86.58,2.65a4.53,4.53,0,0,1-4.58-.34l-5.32-3.07c-1.55-.9-1.94-1.86-.58-2.64A4.53,4.53,0,0,1,135,342.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.56,346l-.89.51-10.27-5.93,1.26-.73,9.48,3.1-7.43-4.28.88-.51,10.28,5.93-1,.6-10.58-3.49Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Implementation--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.46,395.47l27.25,15.77a1.78,1.78,0,0,0,1.59,0L231.83,370a1.69,1.69,0,0,0,.78-1.37v-2.8a1.77,1.77,0,0,0-.8-1.38l-27.25-15.76a1.78,1.78,0,0,0-1.59,0l-71.53,41.28a1.75,1.75,0,0,0-.78,1.37v2.81A1.75,1.75,0,0,0,131.46,395.47Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.81,364.4a1.82,1.82,0,0,1,.8,1.38v2.8a1.69,1.69,0,0,1-.78,1.37L160.3,411.24a1.61,1.61,0,0,1-.83.18l0-4.63a1.59,1.59,0,0,0,.79-.19l71.53-41.28A.49.49,0,0,0,231.81,364.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.32,390c-.31.26-.27.61.12.84l27.25,15.76a1.6,1.6,0,0,0,.8.19l0,4.64a1.59,1.59,0,0,1-.76-.2l-27.25-15.76a1.74,1.74,0,0,1-.8-1.37v-2.8A1.78,1.78,0,0,1,131.32,390Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.44,390.84,158.7,406.6a1.76,1.76,0,0,0,1.58,0l64-36.93,7.54-4.35c.44-.25.44-.66,0-.92l-27.25-15.76a1.78,1.78,0,0,0-1.59,0l-71.53,41.28A.49.49,0,0,0,131.44,390.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92,390.38l71.37-41.19a1.13,1.13,0,0,1,1,0l27.1,15.67L224,369.13l-64,36.92a1.13,1.13,0,0,1-1,0l-27.09-15.67m-.75.2a.84.84,0,0,0,.27.26L158.7,406.6a1.76,1.76,0,0,0,1.58,0l64-36.93,7.54-4.35c.31-.18.4-.44.27-.66a.68.68,0,0,0-.27-.26l-27.25-15.76a1.78,1.78,0,0,0-1.59,0l-71.53,41.28c-.31.18-.4.44-.27.66Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.51,392.62l10.28,5.93-1,.57-10.27-5.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.07,396.06l-.95.55-9.66-3.87,8.2,4.73-.87.5L146.51,392l1.39-.8,9.67,3.89-6.8-5.55,1.39-.8,10.28,5.93-.95.54-8.26-4.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.12,387.07a4.32,4.32,0,0,1,4.51.29l1.23.72c1.63.94,1.82,1.81.41,2.62l-.88.51,4.05,2.34-1,.57-10.27-5.93Zm5.12,3c.74-.42.7-.86-.28-1.43l-1.37-.79a2.28,2.28,0,0,0-2.43-.22l-.95.55,4.16,2.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,391.38l-10.28-5.94,1-.57,9.24,5.33,2.54-1.46,1,.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.93,383.77l1,.59-2.17,1.26,3.65,2.11,2.67-1.54,1,.6-3.66,2.11L162.21,383l3.67-2.11,1,.6L164.25,383l3.51,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,384.36l-1,.55L169.73,381l8.19,4.73-.86.5-10.28-5.93,1.38-.8,9.67,3.89L171,377.88l1.38-.8L182.7,383l-.94.54-8.27-4.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16,377.29l1,.59L180,379.14l3.66,2.11,2.67-1.54,1,.6-3.66,2.11-10.28-5.93,3.66-2.11,1.05.6-2.67,1.54,3.5,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.17,379.27l-.89.52L178,373.85l1.25-.72,9.49,3.1-7.43-4.29.88-.51,10.28,5.94-1,.59-10.59-3.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.79,376l-9.23-5.33-1.64.94-1-.6,4.27-2.46,1,.6-1.64.94,9.23,5.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.56,372.62l1.73,1.39-.92.53-8.57-6.92,1.44-.83,12,4.95-1,.58-2.41-1Zm-.85-.64,2-1.15L190.75,368Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.29,370.55l-9.24-5.34-1.64,1-1-.6,4.27-2.47,1.05.61-1.64.94,9.23,5.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.32,362.12l10.28,5.94-1,.57-10.28-5.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74,363c-1.57-.9-1.91-1.88-.55-2.66a4.55,4.55,0,0,1,4.63.31l5.32,3.07c1.56.89,1.91,1.88.54,2.67a4.6,4.6,0,0,1-4.62-.32Zm6.36,2.54a2.49,2.49,0,0,0,2.53.25c.73-.42.52-.92-.42-1.47l-5.43-3.13a2.48,2.48,0,0,0-2.54-.25c-.72.41-.5.93.42,1.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.44,364.11l-.89.51-10.28-5.93,1.26-.73,9.49,3.1-7.43-4.29.88-.5,10.27,5.93-1,.59-10.58-3.48Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Verification--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.3,424.92l27.25,15.76a1.75,1.75,0,0,0,1.59,0l71.53-41.29a1.69,1.69,0,0,0,.78-1.37v-2.8a1.77,1.77,0,0,0-.8-1.38L255.4,378.09a1.78,1.78,0,0,0-1.59,0l-71.53,41.28a1.71,1.71,0,0,0-.78,1.37v2.81A1.75,1.75,0,0,0,182.3,424.92Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.65,393.85a1.82,1.82,0,0,1,.8,1.38V398a1.71,1.71,0,0,1-.78,1.37l-71.53,41.29a1.61,1.61,0,0,1-.83.18l0-4.63a1.59,1.59,0,0,0,.79-.19l71.53-41.28A.49.49,0,0,0,282.65,393.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.16,419.45c-.31.26-.27.61.12.84l27.25,15.76a1.6,1.6,0,0,0,.8.19l0,4.63a1.45,1.45,0,0,1-.76-.19L182.3,424.92a1.74,1.74,0,0,1-.8-1.37v-2.81A1.78,1.78,0,0,1,182.16,419.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.28,420.29l27.25,15.76a1.78,1.78,0,0,0,1.59,0l64-36.93,7.54-4.35c.44-.25.44-.66,0-.92L255.4,378.09a1.78,1.78,0,0,0-1.59,0l-71.53,41.28C181.84,419.62,181.84,420,182.28,420.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.76,419.83l71.37-41.19a1.13,1.13,0,0,1,1,0l27.1,15.67-7.39,4.27-64,36.92a1.13,1.13,0,0,1-1,0l-27.09-15.67m-.75.2a.68.68,0,0,0,.27.26l27.25,15.76a1.78,1.78,0,0,0,1.59,0l64-36.93,7.54-4.35c.31-.18.4-.44.27-.66a.68.68,0,0,0-.27-.26L255.4,378.09a1.78,1.78,0,0,0-1.59,0l-71.53,41.28c-.31.18-.4.44-.27.66Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.63,417.64,213,422l-7.51-6,.92-.53,8.61,6.89-1.46.85-12-5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.92,415.81l1,.59-2.17,1.26,3.65,2.11,2.67-1.55,1,.61-3.66,2.11L207.2,415l3.66-2.12,1,.61L209.23,415l3.51,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.76,411.22a4,4,0,0,1,4.33.21l.84.48c1.13.66,1.49,1.26,1,1.86a4.1,4.1,0,0,1,3.26.6l1.6.92a4.79,4.79,0,0,0,1.41.61l-1,.58a5.17,5.17,0,0,1-1.42-.63l-1.61-.93a2.55,2.55,0,0,0-2.83-.13l-.7.4,4.39,2.54-1,.57-10.27-5.94Zm4.59,2.94c.79-.45,1-.89-.15-1.54l-1-.57a2.27,2.27,0,0,0-2.43-.21l-1,.55,3.8,2.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.78,408.9l10.27,5.93-1,.58-10.27-5.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,409.32l1,.6-2,1.19,4.45,2.56-1,.58-10.28-5.94,3.54-2,1,.6-2.54,1.47,3.74,2.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.11,405.24l10.27,5.94-1,.57-10.27-5.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.54,403.82l.92.54-.94.54-1-.57a2.49,2.49,0,0,0-2.53-.25c-.71.41-.48.92.44,1.46l5.43,3.13a2.47,2.47,0,0,0,2.53.25c.72-.41.48-.92-.44-1.45l-1.34-.77.94-.55,1.28.74c1.55.9,2,1.86.58,2.65a4.53,4.53,0,0,1-4.59-.34l-5.31-3.07c-1.56-.89-1.95-1.86-.59-2.64A4.54,4.54,0,0,1,231.54,403.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.17,406l1.72,1.39L240,408,231.41,401l1.43-.83,12,4.95-1,.57-2.41-1Zm-.86-.65,2-1.14-6.93-2.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.9,404l-9.24-5.34-1.64.95-1-.6,4.27-2.47,1,.6-1.64.95,9.24,5.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.93,395.53l10.28,5.94-1,.57-10.27-5.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.35,396.42c-1.57-.9-1.91-1.88-.55-2.66a4.55,4.55,0,0,1,4.63.31l5.32,3.06c1.55.9,1.91,1.89.53,2.68a4.6,4.6,0,0,1-4.62-.32ZM250.7,399a2.51,2.51,0,0,0,2.54.25c.72-.42.51-.93-.43-1.47l-5.43-3.13a2.48,2.48,0,0,0-2.54-.25c-.71.41-.49.93.43,1.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,397.52l-.88.51-10.28-5.93,1.26-.73,9.48,3.1-7.42-4.29.87-.5,10.28,5.93-1,.59-10.58-3.48Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Maintenance--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.14,454.37l27.25,15.76a1.72,1.72,0,0,0,1.59,0l71.53-41.28a1.69,1.69,0,0,0,.78-1.37v-2.81a1.77,1.77,0,0,0-.8-1.37l-27.25-15.76a1.78,1.78,0,0,0-1.59,0l-71.53,41.28a1.71,1.71,0,0,0-.78,1.37V453A1.75,1.75,0,0,0,233.14,454.37Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.49,423.3a1.82,1.82,0,0,1,.8,1.37v2.81a1.71,1.71,0,0,1-.78,1.37L262,470.13a1.52,1.52,0,0,1-.83.19l0-4.63a1.59,1.59,0,0,0,.79-.19l71.53-41.28A.49.49,0,0,0,333.49,423.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233,448.9c-.31.26-.27.61.12.84l27.25,15.76a1.72,1.72,0,0,0,.8.19l0,4.63a1.45,1.45,0,0,1-.76-.19l-27.25-15.76a1.74,1.74,0,0,1-.8-1.37v-2.81A1.74,1.74,0,0,1,233,448.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.12,449.74l27.25,15.76a1.78,1.78,0,0,0,1.59,0l64-36.93,7.54-4.35c.44-.26.44-.66,0-.92l-27.25-15.76a1.78,1.78,0,0,0-1.59,0l-71.53,41.28C232.68,449.07,232.68,449.48,233.12,449.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,449.28,305,408.09a1.13,1.13,0,0,1,.95,0L333,423.76,325.63,428l-64,36.93a1.13,1.13,0,0,1-.95,0L233.6,449.28m-.75.2a.68.68,0,0,0,.27.26l27.25,15.76a1.78,1.78,0,0,0,1.59,0l64-36.93,7.54-4.35c.31-.18.4-.44.27-.66a.68.68,0,0,0-.27-.26l-27.25-15.76a1.78,1.78,0,0,0-1.59,0l-71.53,41.28c-.31.18-.4.44-.27.66Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.47,452.83l-1,.55-9.65-3.87,8.19,4.73-.87.5-10.27-5.94,1.38-.8,9.67,3.9-6.79-5.56,1.38-.8,10.28,5.94-.94.54-8.27-4.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.79,449.12l1.73,1.39-.92.53L259,444.12l1.43-.83,12,4.95-1,.57-2.41-1Zm-.86-.65,2-1.14L261,444.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.94,441.29l10.27,5.93-1,.57-10.28-5.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.11,446.13l-.89.51-10.28-5.93,1.26-.73,9.49,3.1-7.43-4.29.87-.5,10.28,5.93-1,.59-10.58-3.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.73,442.88l-9.24-5.33-1.64.95-1-.6,4.27-2.47,1,.6-1.64,1,9.24,5.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.48,435.83l1,.6-2.17,1.25,3.65,2.11,2.67-1.54,1,.6L285,441,274.77,435l3.66-2.11,1,.6-2.67,1.54,3.51,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5,437.82l-.89.51-10.28-5.93,1.26-.73,9.49,3.1-7.43-4.29.88-.5,10.27,5.93-1,.59L282.19,433Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.76,433.55l1.72,1.39-.91.53L286,428.55l1.44-.83,12,4.95-1,.58-2.41-1Zm-.86-.64,2-1.15L288,428.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.06,431.72l-.89.51L289.9,426.3l1.26-.73,9.48,3.1-7.43-4.29.88-.5,10.28,5.93-1,.59-10.59-3.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.52,422.45l.92.54-.94.54-1-.57a2.49,2.49,0,0,0-2.53-.25c-.71.41-.48.92.45,1.46l5.43,3.13a2.47,2.47,0,0,0,2.52.26c.73-.42.49-.93-.44-1.46l-1.33-.77.94-.55,1.27.74c1.56.9,1.95,1.86.58,2.65a4.51,4.51,0,0,1-4.58-.34l-5.32-3.06c-1.55-.9-1.94-1.86-.58-2.65A4.53,4.53,0,0,1,301.52,422.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.66,421.3l1,.59-2.18,1.26,3.66,2.11,2.67-1.54,1,.6-3.66,2.11-10.28-5.93,3.66-2.11,1,.6L302,420.53l3.51,2Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lines--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.05,198.38a.47.47,0,0,1-.25-.07L97.59,175.1a.5.5,0,0,1-.18-.68.5.5,0,0,1,.68-.18l40.21,23.21a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,288.62a.5.5,0,0,1-.5-.5V186.45a.49.49,0,0,1,.5-.49.5.5,0,0,1,.5.49V288.12A.5.5,0,0,1,118,288.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.41,289.66A6.05,6.05,0,0,0,118,294.5c1.4.81,2.53-.05,2.53-1.91a6.08,6.08,0,0,0-2.53-4.85C116.55,286.94,115.41,287.79,115.41,289.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,251.85a.47.47,0,0,1-.25-.07L148.4,228.57a.5.5,0,0,1,.5-.87l40.21,23.22a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.76,318a.5.5,0,0,1-.5-.5V239.92a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v77.55A.51.51,0,0,1,168.76,318Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.22,319a6.08,6.08,0,0,0,2.54,4.84c1.4.81,2.53-.05,2.53-1.92a6.07,6.07,0,0,0-2.53-4.84C167.36,316.28,166.22,317.14,166.22,319Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.67,305.35a.47.47,0,0,1-.25-.07l-40.21-23.21a.5.5,0,0,1-.18-.68.5.5,0,0,1,.68-.18l40.21,23.21a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.57,347.32a.5.5,0,0,1-.5-.5v-53.4a.49.49,0,0,1,.5-.49.5.5,0,0,1,.5.49v53.4A.5.5,0,0,1,219.57,347.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,348.36a6.08,6.08,0,0,0,2.54,4.84c1.4.81,2.53-.05,2.53-1.92a6.07,6.07,0,0,0-2.53-4.84C218.17,345.63,217,346.49,217,348.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48,358.86a.57.57,0,0,1-.25-.06L250,335.58a.5.5,0,0,1-.18-.68.49.49,0,0,1,.68-.18l40.21,23.21a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.38,376.66a.5.5,0,0,1-.5-.5V346.93a.49.49,0,0,1,.5-.49.5.5,0,0,1,.5.49v29.23A.5.5,0,0,1,270.38,376.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.84,377.7a6.09,6.09,0,0,0,2.54,4.85c1.4.8,2.53-.05,2.53-1.92a6,6,0,0,0-2.53-4.84C269,375,267.84,375.84,267.84,377.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.29,412.34a.57.57,0,0,1-.25-.06l-40.21-23.22a.5.5,0,0,1,.5-.86l40.21,23.21a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.19,406a.5.5,0,0,1-.5-.5v-5.09a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v5.09A.5.5,0,0,1,321.19,406Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.65,407.05a6.05,6.05,0,0,0,2.54,4.84c1.4.81,2.53-.05,2.53-1.91a6.08,6.08,0,0,0-2.53-4.85C319.79,404.33,318.65,405.18,318.65,407.05Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stairs--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Strairs--inject-451"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 199.46,
    y1: 266.14,
    x2: 321.69,
    y2: 195.39,
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.47 266.13 250.27 295.47 372.5 224.73 321.69 195.39 199.47 266.13",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.47 266.13 250.27 295.47 372.5 224.73 321.69 195.39 199.47 266.13",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.5 224.73 372.5 248.89 250.27 319.63 250.27 295.47 372.5 224.73",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.27 319.63 301.08 348.96 423.31 278.22 372.5 248.89 250.27 319.63",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.27 319.63 301.08 348.96 423.31 278.22 372.5 248.89 250.27 319.63",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.31 278.22 423.31 302.38 301.08 373.12 301.08 348.96 423.31 278.22",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.08 373.12 351.89 402.46 474.12 331.71 423.31 302.38 301.08 373.12",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.08 373.12 351.89 402.46 474.12 331.71 423.31 302.38 301.08 373.12",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.12 331.71 474.12 358.86 351.89 429.61 351.89 402.46 474.12 331.71",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.84 159.15 148.65 188.48 270.88 117.74 220.07 88.41 97.84 159.15",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.84 159.15 148.65 188.48 270.88 117.74 220.07 88.41 97.84 159.15",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.88 117.74 270.88 141.9 148.65 212.64 148.65 188.48 270.88 117.74",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.65 212.64 199.46 241.98 321.69 171.23 270.88 141.9 148.65 212.64",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.65 212.64 199.46 241.98 321.69 171.23 270.88 141.9 148.65 212.64",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.69 171.23 321.69 195.39 199.46 266.13 199.46 241.98 321.69 171.23",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.08 373.12 301.08 348.96 250.27 319.63 250.27 295.47 199.47 266.13 199.46 266.14 199.46 266.13 199.46 241.98 148.65 212.64 148.65 188.48 97.84 159.15 97.84 166.07 142.68 191.93 142.68 216.09 193.49 245.43 193.49 269.58 193.49 269.59 244.3 298.92 244.3 323.08 295.11 352.42 295.11 376.57 345.92 405.91 345.92 426.15 351.89 429.61 351.89 402.46 301.08 373.12",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.08 373.12 301.08 348.96 250.27 319.63 250.27 295.47 199.47 266.13 199.46 266.14 199.46 266.13 199.46 241.98 148.65 212.64 148.65 188.48 97.84 159.15 97.84 166.07 142.68 191.93 142.68 216.09 193.49 245.43 193.49 269.58 193.49 269.59 244.3 298.92 244.3 323.08 295.11 352.42 295.11 376.57 345.92 405.91 345.92 426.15 351.89 429.61 351.89 402.46 301.08 373.12",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-451"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.79 168.71 157.34 183.46 164.84 179.12 139.29 164.38 131.79 168.71",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.84 187.03 164.84 179.12 157.34 183.46 157.34 191.36 153.17 193.77 161.09 199.17 169.01 184.62 164.84 187.03",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-451"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "182.6 222.21 208.15 236.96 215.65 232.62 190.1 217.87 182.6 222.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.65 240.53 215.65 232.62 208.15 236.96 208.15 244.86 203.98 247.27 211.9 252.67 219.82 238.12 215.65 240.53",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-451"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "233.41 275.71 258.96 290.46 266.46 286.12 240.91 271.37 233.41 275.71",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.46 294.02 266.46 286.12 258.96 290.46 258.96 298.36 254.79 300.76 262.71 306.17 270.63 291.62 266.46 294.02",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-451"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "284.23 329.2 309.77 343.95 317.27 339.61 291.73 324.86 284.23 329.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.27 347.52 317.27 339.61 309.77 343.95 309.77 351.85 305.6 354.26 313.52 359.66 321.44 345.11 317.27 347.52",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-451"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "335.03 382.69 360.58 397.44 368.08 393.1 342.53 378.36 335.03 382.69",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.08 401.01 368.08 393.1 360.58 397.44 360.58 405.34 356.41 407.75 364.33 413.15 372.25 398.6 368.08 401.01",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M192.85,146.26l-7-4a.46.46,0,0,1,0-.87l53.73-31a1.67,1.67,0,0,1,1.51,0l7,4a.46.46,0,0,1,0,.87l-53.73,31A1.67,1.67,0,0,1,192.85,146.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-451",
    cx: 162.31,
    cy: 154.1,
    rx: 20.09,
    ry: 11.6,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-451"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "167.59 150.14 168.82 149.55 167.62 149.21 167.59 150.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73,152.45s-14.41-6.54-14.6-5.58a1.41,1.41,0,0,0,0,.58l0,0,.25,1.79a4.34,4.34,0,0,0,2.24.95l0-.93a7.68,7.68,0,0,1,1.27.68,13.09,13.09,0,0,1,2.48,2.91c.71.9,2,1.33,3.88,1.61s3.83-.08,4.34-.61A1.41,1.41,0,0,0,179.73,152.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.33,152.11c-.14-.14-.65-.71-1.34-1.32a25.87,25.87,0,0,0-2.08-1.77,8.3,8.3,0,0,1-1-.85c-.25-.27-.49-.55-.71-.84a15.18,15.18,0,0,1-1.72-2.94,6.09,6.09,0,0,1-.6-1.53,9.89,9.89,0,0,1-.16-1.71c0-2.57.06-3,.08-4.94l-6.11.15c.2,1.09.49,2.58.59,3.81a6.77,6.77,0,0,1-.56,4.17,5.44,5.44,0,0,0-.58,1.67,2.65,2.65,0,0,0,1.55,2.27c.71.39,1.52.57,2.21,1a7.26,7.26,0,0,1,1.78,1.76,7.2,7.2,0,0,0,1.55,1.79,6.44,6.44,0,0,0,2.35.81,12.82,12.82,0,0,0,3.16.18C179.21,153.7,180.34,153.17,179.33,152.11Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.51,151.06c-.62-.52-1.5-1.27-2.56-2.11a2.75,2.75,0,0,0-2.24.19,4.59,4.59,0,0,0-2.53,2.67,3.07,3.07,0,0,0,1.74,1.53c2.47,1.09,6.91.78,7-.35C179.92,152.27,179.26,151.69,178.51,151.06Zm-12.68-7.13s-.15.37-.53,1.09a2,2,0,0,0,0,2.18,3.22,3.22,0,0,0,2.16,1.47A4.45,4.45,0,0,0,165.83,143.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.07,145.86c.4.65-.1,3.08,0,4.81.09,1.57.52,4.32.05,5.87-.56,1.84-1.71,4-3.86,2.24a6.21,6.21,0,0,1-2.29-4.73,19,19,0,0,1,1-5.68c.61-2.25.84-3.45.84-3.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.76,134.22c-.16,3.67.27,6.25.3,8.6a17,17,0,0,1-.34,3.18c-.32,1.5-.85,3.58-1.07,4.56a6,6,0,0,0-.08,3.74,2.6,2.6,0,0,0,.16.34c.67,1.26,2.37,2.2,2.91,2.05a.94.94,0,0,0,1,.33l.18,0,.18-.08a1.81,1.81,0,0,0,.9-1.15,1.59,1.59,0,0,0,.09-.33,13.61,13.61,0,0,0,.18-3.9c0-1,0-2,.09-3.39a56.74,56.74,0,0,1,.79-7.66c.36-1.44.81-3.25,1.28-5.18Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.31,152.32c1.34-.58,5.23-.66,5.85,1.2,0,1.75,0,2.93-1.1,4.45-1.49,2-3.44-.12-4.19-1.48A6.91,6.91,0,0,1,148.31,152.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82,86.25c-1.89,3.33-3.42,6.13-3.91,14.93-.56,9.93-.47,13.71-.52,14.9s-.84,3.4-1.51,9.3,0,20.2,0,20.2.47,1,2.77,1.18a6,6,0,0,0,3.37-.52s3.37-18.78,4.2-22.33,3.25-15.23,3.25-15.23l.8,11.14a29.13,29.13,0,0,0-.06,8.44c.61,5.18,2.17,15,2.17,15s.9.9,3.67.85c2.95-.06,3.56-.86,3.56-.86s.67-21.07.71-26.94.39-21.1-1.43-29.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,97.41l-2,11.27.8,11.14V108.56l1.76-9.25c1.45-.33,4.74-2,5.66-4.42C168.49,97.16,164.49,97.41,164.49,97.41Zm-6.69-6.65c.26-.94.54-1.88.85-2.83a14.19,14.19,0,0,0-1.32,2.68,24,24,0,0,0-.88,2.85,26.87,26.87,0,0,0-.57,2.92,19.81,19.81,0,0,0-.23,3c.25-1,.48-1.92.71-2.88s.46-1.91.7-2.86S157.55,91.71,157.8,90.76ZM156.36,90c.33-.58.66-1.15,1-1.76A10.71,10.71,0,0,0,156,89.77a15.54,15.54,0,0,0-1.13,1.69A13.41,13.41,0,0,0,154,93.3a7.76,7.76,0,0,0-.47,2l.93-1.77c.32-.58.63-1.16,1-1.73S156,90.62,156.36,90Zm-1.48,37.67c-.58,3.06-1.13,6.12-1.63,9.18.75-3,1.45-6,2.12-9.08s1.31-6.06,1.94-9.12,1-6.15,1.32-9.24.59-6.18.8-9.28c-.46,3.07-.87,6.15-1.29,9.22s-.86,6.15-1.46,9.18S155.45,124.66,154.88,127.71Zm15.81-15.12c.05,1.34.12,2.7.09,4s0,3.9-.05,5.25c0,0-.08,7.93.16,10.94.34-2.69.42-13.46.53-16.18s-.21-5.42-.43-8.12-.55-5.39-1-8.07l.45,8.1C170.56,109.89,170.64,111.24,170.69,112.59Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.19,52.9a3.24,3.24,0,0,0-2.37,2.66,6.46,6.46,0,0,0-.1,2,7.53,7.53,0,0,1,.27,2.62,7.48,7.48,0,0,1-.53,1.31,3.46,3.46,0,0,0-.21,2.28,2.22,2.22,0,0,0,1.59,1.56,3,3,0,0,1-.36-1.63c0,.34.39.86.59,1.1a3,3,0,0,0,1,.78A5.07,5.07,0,0,0,159,66a2.11,2.11,0,0,0,1.26-.47,4.9,4.9,0,0,0,.79.56,2.87,2.87,0,0,0,2.57.05,1.54,1.54,0,0,1,.3-.11,1,1,0,0,1,.38,0,5.06,5.06,0,0,0,3.51-.35,3.76,3.76,0,0,0,2-2.8,2.49,2.49,0,0,1,.28,1.67,2.26,2.26,0,0,0,.71-1.88,4.06,4.06,0,0,0-1.18-2.44c-.41-.39-1.06-.83-1-1.45a3.64,3.64,0,0,1,.87-1.67,4.85,4.85,0,0,0-.32-5.87,6.6,6.6,0,0,0-3.91-2.15C162.38,48.54,156.89,49.17,156.19,52.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.35,71.66a1.76,1.76,0,0,0-1-.19,11.06,11.06,0,0,0-1.63.39,6.82,6.82,0,0,1-3,.25c-.17-.06-.5-.22-.21-.37a7,7,0,0,0,1.11-.6,1.47,1.47,0,0,0,.65-1,.5.5,0,0,0-.08-.36c-.11-.14-.23-.1-.36-.05s-.29.08-.44.12l-.91.23a10.64,10.64,0,0,0-4.89,2.36A9.37,9.37,0,0,1,186,74.35c-1.88,1.09-6.71,3.8-6.71,3.8s-3.54-4.49-4.77-6.08c-2.19-2.79-2.82-3.59-5.81-4.1l.89,9.35A89.47,89.47,0,0,0,175.88,84c2.24,1.75,2.85,1.58,4.65.5a31.56,31.56,0,0,0,5.2-3.88c2.29-1.94,3.1-2.6,3.85-3.15a4.42,4.42,0,0,1,2.46-.57,8.44,8.44,0,0,0,2.29-.32,7.82,7.82,0,0,0,1.89-.71,2.45,2.45,0,0,0,.81-.56,5.94,5.94,0,0,1,.35-.72c.21-.25.52-.39.69-.65a2.85,2.85,0,0,0,.25-.71,1.26,1.26,0,0,1,.76-.7,1,1,0,0,0,.44-.3C199.7,72,199.55,71.78,199.35,71.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.28,78.15a4.39,4.39,0,0,0-2.45,3.47c-.68-2.59,2-4,2-4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.56,72.56a5.56,5.56,0,0,1-2.51,1.8,2.32,2.32,0,0,0,1.58-.32A2.13,2.13,0,0,0,192.56,72.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.86,67.75c3.47.68,3.75,1.68,5.7,4s4.8,6.1,4.8,6.1l5.25-2.72a3,3,0,0,0,.73,2.35,4.37,4.37,0,0,0,2.38,1.75s-2,1.75-4.89,4.06-4.09,2.69-5.58,1.88-8.24-7.4-8.24-7.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.36,77.86a4.77,4.77,0,0,0-2.3,3.49,4.3,4.3,0,0,1,1.86-4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-451",
    d: "M153,90.79c-1.11-.9-.25-2.51.36-7.05a19.88,19.88,0,0,0-.71-4.86s2.6-3.91,1.76-10.7l4-.75,6.55-.1,3.77.64a24.08,24.08,0,0,1,3.48,4.11,6.53,6.53,0,0,1-.31,8.16,40.91,40.91,0,0,0,.09,4.88c.25,2.26,1.51,4.47.19,5.59C168.31,94,158.16,94.2,153,90.79Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.58,62.54a2.13,2.13,0,0,1-1.93-.72c-1-1.1-1.12-2.22-.65-3a1.59,1.59,0,0,1,2-.59c.72.44.74.8,1,1.3s1,.11.74-1.9c1.4-.65,1.17-3,1.93-3.89a3.16,3.16,0,0,1,3.76-.74,2.6,2.6,0,0,1,2.66-.17c.94.49,1.56,1.53,1.9,5.11s0,5.51-1.07,6.5a4.49,4.49,0,0,1-3.08,1.16l.05,1.69s3.73,3.54-1.08,3.19a7.59,7.59,0,0,1-5.45-3l0-5.53S158.29,62.41,157.58,62.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,62a1.07,1.07,0,0,1-1.34.7,1.06,1.06,0,0,1-.71-1.32Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33,61.71a1,1,0,0,0,.75,1,1,1,0,0,0,.38,0A1.08,1.08,0,0,0,163.33,61.71Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.84,56.45l-1.33.76a.76.76,0,0,1,.27-1A.79.79,0,0,1,162.84,56.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.24,56.71l-1.4-.62a.74.74,0,0,1,1-.4A.79.79,0,0,1,168.24,56.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,58.12a.6.6,0,1,0,.6-.6A.6.6,0,0,0,162.12,58.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.32,
    cy: 57.81,
    r: 0.6,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.07 59.65 165.29 60.41 164.69 56.64 167.07 59.65",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M164.88,65.64c-1.88-.07-4.63-.73-5.41-2.89a3.82,3.82,0,0,0,3.11,3.3,9.91,9.91,0,0,0,2.33.37Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,66.86v.47a20.33,20.33,0,0,1,4.62,5.23c2,3.24,1.77,7.22,1.87,11.39s.19,13.11.19,13.11a4.83,4.83,0,0,0,2.76-1.79c0-2.33-1.13-10.75-1.37-12.74s.42-3.3.75-5.14.41-5.21-4.89-9.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,67A23.48,23.48,0,0,1,160.25,75c.06,4.07-1.61,23.82-1.61,23.82s-5.75-.25-8.6-1.56c.65-3.2,2.06-9.42,2.59-11.44a7.7,7.7,0,0,0,.15-4.75,16.8,16.8,0,0,0-.84-2.89L154.18,68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.64,76.79A7.57,7.57,0,0,1,168,75.57c.55-.13,2.48-.82,3.22-1,.46-.1.62.63,0,1.1a15.91,15.91,0,0,1-2.2,1.06,9.58,9.58,0,0,0-1.59,1.42Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.33,71.67c1.26-2.36,2.52-3,5-3.49,1.57,2.88.41,7.75.41,7.75l-1.53,5.83s6.84-.66,7.65-1.12a46.55,46.55,0,0,0,3.74-3.22c1-.86,1.47-.72,2-.63a5.75,5.75,0,0,1,2.26.68.73.73,0,0,1,.29.63c.42.07,1.05.09,1.1.77a1.94,1.94,0,0,1,0,.55.53.53,0,0,1,.27.17c.33.42-.34,1.78-.74,2.1a1.39,1.39,0,0,1-1.17.15c-.43-.07-.21-.49-.21-.49h-.6c-1.34.85-1.49,2.65-3.22,3a11.3,11.3,0,0,0-2.12.3c-3.76,1.06-10,4.49-13.3,4.62s-3.06-1.55-3-3.49C146.17,84,148.08,74,149.33,71.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.41,81.11l-.17.65a7.17,7.17,0,0,0-3.67,2.9A4.74,4.74,0,0,1,153.41,81.11Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.14,78.1l-1.89-.46,1.86.2A1.22,1.22,0,0,1,169.14,78.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.25,79.42l-2.18-.37,2.19.13A1,1,0,0,1,170.25,79.42Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.24,81c.27-.25.29-.4.29-.4s.53,0,.76,0l.3-.07a.82.82,0,0,0,.33-.18.79.79,0,0,1-.31.23,1.39,1.39,0,0,1-.33.1l-.14.26a.37.37,0,0,1,.22.1.51.51,0,0,1,.18.28.69.69,0,0,0-.21-.24A.52.52,0,0,0,169,81a.94.94,0,0,0-.64.33h-.6A4,4,0,0,0,168.24,81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.18,68c-2.48.56-4.47,1.4-5.58,4.69a63.65,63.65,0,0,0-2.38,10.64c-.49,3.43-.43,5,.66,5.71s2.75.65,5.3-.15a61.19,61.19,0,0,0,6.22-2.57,5.79,5.79,0,0,1-1.14-2.84c-.25-1.81.17-2.27.17-2.27l-3.94.44s.9-3.39,1.5-5.73S155.34,69,154.18,68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.49,81.62c-1.66.2-3.59,1-4.27,2.46.5-2.33,3.29-3.11,4.47-3.22Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.6,23.7,190.27,52.14a2,2,0,0,0-.92,1.6v87.51a2,2,0,0,0,.93,1.59l.18.11a2,2,0,0,0,1.85,0l49.33-28.48a2,2,0,0,0,.92-1.6V25.39a2,2,0,0,0-.92-1.59l-.19-.11A2,2,0,0,0,239.6,23.7Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6,23.7,190.27,52.14a2,2,0,0,0-.92,1.6v87.51a2,2,0,0,0,.93,1.59l.18.11a2,2,0,0,0,1.85,0l49.33-28.48a2,2,0,0,0,.92-1.6V25.39a2,2,0,0,0-.92-1.59l-.19-.11A2,2,0,0,0,239.6,23.7Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,112.93a2.05,2.05,0,0,1-1.27,1.73l-48.63,28.07c-.7.41-1.27.08-1.27-.73V55.31h0a2.52,2.52,0,0,1,1.27-2.2L241.29,25a.85.85,0,0,1,1.27.74h0Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,112.93a2.05,2.05,0,0,1-1.27,1.73l-48.63,28.07c-.7.41-1.27.08-1.27-.73V55.31h0a2.52,2.52,0,0,1,1.27-2.2L241.29,25a.85.85,0,0,1,1.27.74h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,25.4v.36a.85.85,0,0,0-1.27-.74L192.66,53.11a2.44,2.44,0,0,0-.93.93s0,0,0,0l-2.11-1.21a1.74,1.74,0,0,1,.67-.7L239.6,23.7a2,2,0,0,1,1.85,0l.19.11A2,2,0,0,1,242.56,25.4Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.56,25.4v.36a.85.85,0,0,0-1.27-.74L192.66,53.11a2.44,2.44,0,0,0-.93.93s0,0,0,0l-2.11-1.21a1.74,1.74,0,0,1,.67-.7L239.6,23.7a2,2,0,0,1,1.85,0l.19.11A2,2,0,0,1,242.56,25.4Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M241.36,109.19a2.13,2.13,0,0,1-1.31,1.79l-46,26.53c-.72.42-1.31.08-1.31-.76V60h0a2.62,2.62,0,0,1,1.3-2.27l46-26.54a.87.87,0,0,1,1.31.76v77.23Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194,58.74,239.74,32.3a.91.91,0,0,1,.79,0l.44.26a.85.85,0,0,1,.39.68v77.11a.86.86,0,0,1-.39.68l-45.79,26.44a.91.91,0,0,1-.79,0l-.44-.26a.89.89,0,0,1-.39-.68V59.42A.88.88,0,0,1,194,58.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.09,137.51l-.15,0h-.31l-.15,0-.09,0-.44-.26a.88.88,0,0,1-.39-.68V59.42a.71.71,0,0,1,.12-.39l1.22.71a.79.79,0,0,0-.11.39v77.11C194.79,137.45,194.91,137.56,195.09,137.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,32.56l-.44-.26a.91.91,0,0,0-.79,0L194,58.74a.88.88,0,0,0-.39.68V72.3l1.23.71,46.57-26.89V33.24A.85.85,0,0,0,241,32.56Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,32.56l-.44-.26a.91.91,0,0,0-.79,0L194,58.74a.88.88,0,0,0-.39.68V72.3l1.23.71,46.57-26.89V33.24A.85.85,0,0,0,241,32.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,33.12c0-.16-.2-.21-.38-.11L195.18,59.45a.78.78,0,0,0-.28.29L193.68,59a.84.84,0,0,1,.27-.29L239.74,32.3a.91.91,0,0,1,.79,0l.44.26A.87.87,0,0,1,241.35,33.12Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,33.12c0-.16-.2-.21-.38-.11L195.18,59.45a.78.78,0,0,0-.28.29L193.68,59a.84.84,0,0,1,.27-.29L239.74,32.3a.91.91,0,0,1,.79,0l.44.26A.87.87,0,0,1,241.35,33.12Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.56,59.42V72.3l1.23.71V60.13a.79.79,0,0,1,.11-.39L193.68,59A.71.71,0,0,0,193.56,59.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip-board--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.74,82.76a.17.17,0,0,1-.1,0,.19.19,0,0,1-.09-.16V76.44a.22.22,0,0,1,.09-.16l5.27-3a.21.21,0,0,1,.19,0,.18.18,0,0,1,.09.16v6.13a.17.17,0,0,1-.09.16l-5.27,3A.16.16,0,0,1,197.74,82.76Zm.18-6.21v5.7l4.9-2.83v-5.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,72.19v.43c0,.23.16.32.36.2l17.85-10.3a.79.79,0,0,0,.36-.62v-.43c0-.23-.16-.32-.36-.21L206.79,71.57A.78.78,0,0,0,206.43,72.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,74.86v.43c0,.23.16.32.36.2l31.57-18.22a.81.81,0,0,0,.36-.63v-.42c0-.23-.16-.32-.36-.21L206.79,74.24A.78.78,0,0,0,206.43,74.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,77.4v.43c0,.23.16.32.36.2l31.57-18.22a.81.81,0,0,0,.36-.63v-.42c0-.23-.16-.32-.36-.21L206.79,76.78A.78.78,0,0,0,206.43,77.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.31 79.89 199.08 78.71 199.49 77.84 200.19 78.52 203.21 72.12 203.74 72.63 200.31 79.89",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,94.06a.17.17,0,0,1-.1,0,.19.19,0,0,1-.09-.16V87.74a.22.22,0,0,1,.09-.16l5.27-3a.21.21,0,0,1,.19,0,.17.17,0,0,1,.09.16v6.13a.17.17,0,0,1-.09.16l-5.27,3A.16.16,0,0,1,197.74,94.06Zm.18-6.21v5.7l4.9-2.83V85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,83.49v.42c0,.23.16.33.36.21l17.85-10.3a.81.81,0,0,0,.36-.63v-.42c0-.23-.16-.32-.36-.21L206.79,82.87A.78.78,0,0,0,206.43,83.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,86.16v.42c0,.23.16.33.36.21l31.57-18.22a.81.81,0,0,0,.36-.63v-.42c0-.23-.16-.32-.36-.21L206.79,85.54A.78.78,0,0,0,206.43,86.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,88.7v.42c0,.23.16.33.36.21l31.57-18.22a.81.81,0,0,0,.36-.63v-.42c0-.23-.16-.32-.36-.21L206.79,88.08A.78.78,0,0,0,206.43,88.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.31 91.19 199.08 90.01 199.49 89.14 200.19 89.81 203.21 83.42 203.74 83.93 200.31 91.19",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,105.64l-.1,0a.22.22,0,0,1-.09-.16V99.33a.19.19,0,0,1,.09-.16l5.27-3a.21.21,0,0,1,.19,0,.19.19,0,0,1,.09.16v6.13a.17.17,0,0,1-.09.16l-5.27,3.05Zm.18-6.21v5.7l4.9-2.82V96.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,95.07v.43c0,.23.16.32.36.21L224.64,85.4a.78.78,0,0,0,.36-.62v-.43c0-.23-.16-.32-.36-.2l-17.85,10.3A.81.81,0,0,0,206.43,95.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,97.74v.43c0,.23.16.32.36.21l31.57-18.23a.79.79,0,0,0,.36-.62V79.1c0-.23-.16-.32-.36-.21L206.79,97.12A.79.79,0,0,0,206.43,97.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,100.28v.43c0,.23.16.32.36.21l31.57-18.23a.79.79,0,0,0,.36-.62v-.43c0-.23-.16-.32-.36-.21L206.79,99.66A.81.81,0,0,0,206.43,100.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.31 102.78 199.08 101.59 199.49 100.73 200.19 101.4 203.21 95 203.74 95.51 200.31 102.78",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,117.22a.16.16,0,0,1-.1,0,.2.2,0,0,1-.09-.16v-6.13a.19.19,0,0,1,.09-.16l5.27-3a.17.17,0,0,1,.19,0,.17.17,0,0,1,.09.16V114a.19.19,0,0,1-.09.16l-5.27,3A.15.15,0,0,1,197.74,117.22Zm.18-6.2v5.7l4.9-2.83v-5.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,106.66v.42c0,.23.16.32.36.21L224.64,97a.78.78,0,0,0,.36-.62v-.42c0-.23-.16-.33-.36-.21L206.79,106A.81.81,0,0,0,206.43,106.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,109.33v.42c0,.23.16.32.36.21l31.57-18.23a.78.78,0,0,0,.36-.62v-.43c0-.23-.16-.32-.36-.2L206.79,108.7A.81.81,0,0,0,206.43,109.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,111.87v.42c0,.23.16.32.36.21l31.57-18.23a.78.78,0,0,0,.36-.62v-.43c0-.22-.16-.32-.36-.2l-31.57,18.22A.81.81,0,0,0,206.43,111.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.31 114.36 199.08 113.18 199.49 112.31 200.19 112.98 203.21 106.59 203.74 107.09 200.31 114.36",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,128.81a.17.17,0,0,1-.1,0,.19.19,0,0,1-.09-.16v-6.13a.22.22,0,0,1,.09-.16l5.27-3a.21.21,0,0,1,.19,0,.17.17,0,0,1,.09.16v6.13a.18.18,0,0,1-.09.16l-5.27,3A.16.16,0,0,1,197.74,128.81Zm.18-6.21v5.7l4.9-2.83v-5.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,118.24v.42c0,.23.16.33.36.21l17.85-10.3a.81.81,0,0,0,.36-.63v-.42c0-.23-.16-.32-.36-.21l-17.85,10.31A.78.78,0,0,0,206.43,118.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,120.91v.42c0,.23.16.33.36.21l31.57-18.22a.81.81,0,0,0,.36-.63v-.42c0-.23-.16-.33-.36-.21l-31.57,18.23A.78.78,0,0,0,206.43,120.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,123.45v.42c0,.23.16.33.36.21l31.57-18.22a.81.81,0,0,0,.36-.63v-.42c0-.23-.16-.32-.36-.21l-31.57,18.23A.78.78,0,0,0,206.43,123.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.31 125.94 199.08 124.76 199.49 123.89 200.19 124.56 203.21 118.17 203.74 118.68 200.31 125.94",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,63.87l16-9.27c.23-.13.42,0,.42.25V55a.91.91,0,0,1-.42.72l-16,9.27c-.23.13-.41,0-.41-.24v-.13A.92.92,0,0,1,198.24,63.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,66.06l9.54-5.51c.24-.13.42,0,.42.25v.12a.9.9,0,0,1-.42.72l-9.54,5.51c-.23.13-.41,0-.41-.24v-.12A.92.92,0,0,1,198.24,66.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.32,45.21l7.13-4.12c.12-.07.21,0,.21.12v.27a.44.44,0,0,1-.21.36L230.32,46c-.11.07-.21,0-.21-.12v-.27A.49.49,0,0,1,230.32,45.21Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.32,48.5l7.13-4.13c.12-.06.21,0,.21.13v.27a.46.46,0,0,1-.21.36l-7.13,4.12c-.11.06-.21,0-.21-.12v-.27A.45.45,0,0,1,230.32,48.5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,46l5.66-3.26c.12-.07.21,0,.21.12v.27a.46.46,0,0,1-.21.36l-5.66,3.27c-.11.06-.21,0-.21-.12v-.27A.49.49,0,0,1,231.79,46Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-451",
    style: {
      opacity: 0.25
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.77,35.61v3.94a3.37,3.37,0,0,1-1.54,2.67l-7.62,4.4a2.38,2.38,0,0,0-.82,1.11,4.5,4.5,0,0,1-.59,1,7.26,7.26,0,0,1-2.79,1.66,5.28,5.28,0,0,1-.92.21l-.37,0a7.92,7.92,0,0,0-2.48.61l-8.91,5.14a1.56,1.56,0,0,1-.78.24,1,1,0,0,1-.52-.14,1.27,1.27,0,0,1-.57-1.17V51.35a3.37,3.37,0,0,1,1.55-2.67l3-1.73h0a.31.31,0,0,1,.4.13.32.32,0,0,1-.08.41l0,0-3,1.73a2.76,2.76,0,0,0-1.23,2.12v3.94a.69.69,0,0,0,.25.62.7.7,0,0,0,.66-.1l8.91-5.15A8.18,8.18,0,0,1,216,50l.37,0a5,5,0,0,0,.81-.19,6.72,6.72,0,0,0,2.51-1.47,3.87,3.87,0,0,0,.49-.83,2.9,2.9,0,0,1,1.08-1.37l7.62-4.4a2.78,2.78,0,0,0,1.22-2.12V35.61a.69.69,0,0,0-.25-.62.68.68,0,0,0-.65.1l-2.6,1.5a2.77,2.77,0,0,0-.33-.55l2.61-1.5a1.25,1.25,0,0,1,1.29-.1A1.27,1.27,0,0,1,230.77,35.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.21,35.68h0a.78.78,0,0,1,.81.07,2.51,2.51,0,0,1,1.13,2,.79.79,0,0,1-.34.74h0L208.73,48.9l-1.6-2.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.94,47.52l18.88-10.91a2.43,2.43,0,0,0-.8-.85l-.11,0L207.32,46.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.94,46.2c-.63-.36-1.14-.07-1.14.65a2.5,2.5,0,0,0,1.14,2c.62.36,1.13.06,1.13-.66A2.51,2.51,0,0,0,207.94,46.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.09,35.89v3.94a3.37,3.37,0,0,1-1.54,2.67l-7.62,4.4a2.38,2.38,0,0,0-.82,1.11,4.5,4.5,0,0,1-.59,1,7.26,7.26,0,0,1-2.79,1.66,5.28,5.28,0,0,1-.92.21l-.37,0a7.92,7.92,0,0,0-2.48.61l-8.91,5.14a1.56,1.56,0,0,1-.78.24,1,1,0,0,1-.52-.14,1.27,1.27,0,0,1-.57-1.17V51.63A3.37,3.37,0,0,1,204.73,49l3-1.73h0a.31.31,0,0,1,.4.13.32.32,0,0,1-.08.41l0,0-3,1.73a2.79,2.79,0,0,0-1.23,2.12v3.94a.69.69,0,0,0,.25.62.7.7,0,0,0,.66-.1l8.91-5.15a8.18,8.18,0,0,1,2.71-.68l.37,0a5,5,0,0,0,.81-.19A6.65,6.65,0,0,0,220,48.55a3.89,3.89,0,0,0,.5-.83,2.82,2.82,0,0,1,1.07-1.37l7.62-4.4a2.78,2.78,0,0,0,1.22-2.12V35.89a.53.53,0,0,0-.9-.52l-2.6,1.5a2.77,2.77,0,0,0-.33-.55l2.61-1.5a1.25,1.25,0,0,1,1.29-.1A1.27,1.27,0,0,1,231.09,35.89Z",
    style: {
      fill: "#455a64"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M243.89,189.12c8.43,4.93,8.43,12.91,0,17.84s-22.11,4.92-30.55,0-8.43-12.91,0-17.84S235.45,184.2,243.89,189.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.78,187.2l-.63-5.68,7-.76s-.27,4.49-.22,6.55a11.85,11.85,0,0,0,.71,2.79s-2.76,1.45-4.2.86a5,5,0,0,1-2.35-3.27Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,197a1.3,1.3,0,0,1-.41,1.34,7,7,0,0,1-5,1,8.32,8.32,0,0,1-4.52-2A9.88,9.88,0,0,0,233.5,195a7.69,7.69,0,0,1-2.61-1.44c-.3-.32-.19-1.67-.19-1.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.72,186.66s-.13.06-.21.37-.22,1.45-.4,2.06a10.74,10.74,0,0,0-.39,3.29c.1.7,1.95,1.61,3,2.05a13.37,13.37,0,0,1,3.26,2.25,9.61,9.61,0,0,0,4.92,2.07c1.83.07,3.92-.43,4.43-1.25.63-1,1.11-2.2-1.54-3.56-.5-.26-2.25-1.4-2.85-1.81a7.87,7.87,0,0,1-3.42-4,1,1,0,0,0-.36-.58.94.94,0,0,0-.53-.07,18.41,18.41,0,0,0-2.68.39c-.38.16-.9.33-.92.79a1.93,1.93,0,0,0,.08.48c0,.09,0,.22,0,.27a.21.21,0,0,1-.25-.08,6,6,0,0,1-.69-.9,10.42,10.42,0,0,0-.67-.82c-.14-.12-.32-.18-.45-.31A1.13,1.13,0,0,1,231.72,186.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,196.68a17.39,17.39,0,0,0-1.42-1.15h0s3.1,2.06,4.43,1.25a1.14,1.14,0,0,0,.48-1.44,11.94,11.94,0,0,1,3.8-1.69h0l.52.3c2.08.93,2.31,2,1.89,3.37-.51.82-2.38,1.6-4.75,1.5A9.87,9.87,0,0,1,237,196.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.25,194.68c1.65.74.92,1,.44,1.07s-3.23-1.72-4.9-3.15-3.06-3.46-3.7-4a9.36,9.36,0,0,1-.73-.69c.06-.36.11-.7.15-.87s.21-.37.21-.37a2.18,2.18,0,0,0,.27.66c.13.13.31.19.45.31a10.42,10.42,0,0,1,.67.82,6,6,0,0,0,.69.9A21.61,21.61,0,0,0,240.25,194.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.58,195.5a.21.21,0,0,1-.1,0,.17.17,0,0,1,0-.24c.5-.55,2.82-1.82,4.05-1.63a.15.15,0,0,1,.14.18.16.16,0,0,1-.19.14c-1.15-.17-3.36,1.09-3.75,1.53A.2.2,0,0,1,240.58,195.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.16,194.54a.22.22,0,0,1-.11,0,.16.16,0,0,1,0-.23c.5-.56,2.82-1.82,4.06-1.64a.18.18,0,0,1,.14.19.17.17,0,0,1-.2.14c-1.15-.17-3.35,1.09-3.75,1.53A.19.19,0,0,1,239.16,194.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.72,193.62a.14.14,0,0,1-.1,0,.16.16,0,0,1,0-.23c.5-.56,2.82-1.83,4-1.64a.16.16,0,0,1,.14.19.16.16,0,0,1-.19.14c-1.15-.18-3.36,1.09-3.75,1.53A.19.19,0,0,1,237.72,193.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.41,192.59a.15.15,0,0,1-.11,0,.16.16,0,0,1,0-.23c.5-.56,2.83-1.83,4.06-1.64a.17.17,0,0,1,.14.19.18.18,0,0,1-.19.14c-1.16-.18-3.36,1.09-3.76,1.53A.17.17,0,0,1,236.41,192.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.12,191.56a.15.15,0,0,1-.11,0,.17.17,0,0,1,0-.23,6.68,6.68,0,0,1,4.34-1.64.17.17,0,0,1-.05.33,6.48,6.48,0,0,0-4,1.53A.13.13,0,0,1,235.12,191.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.81,189.5l1.55-7-6.86-1.05-.09,6.9s-.52,1.86-.14,2.49,4.51,1.3,4.89.88A7.16,7.16,0,0,0,220.81,189.5Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.15,200.52A6.3,6.3,0,0,1,219,204a2.65,2.65,0,0,1-3.06.58c-1.19-.42-2.7-1.33-3-2.73a7.79,7.79,0,0,1,.17-3.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.41,188.35c-.5,0-.36,1.21-.59,3.32-.25,2.29-1.28,4.09-1.64,5.92-.41,2.1-.33,3.07.45,4.46s3.7,3,5.25,1.34c1.26-1.36,1.39-3,1.38-5.17a48.06,48.06,0,0,1,.14-5.44c.17-1.58.83-3.05.41-3.28-.05.23-.46,1.84-.74,1.81a2.43,2.43,0,0,1,0-.6.71.71,0,0,0-.11-.53,2.25,2.25,0,0,0-.8-.41c-.49-.14-1.35-.32-1.85-.42-.24,0-.49-.09-.74-.12a2.21,2.21,0,0,0-.63,0,.37.37,0,0,0-.28.18.63.63,0,0,0,0,.24,1.57,1.57,0,0,1-.09.43c0,.06-.07.13-.14.11a.14.14,0,0,1-.08-.14C215.35,189.8,215.39,188.48,215.41,188.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,197c-.06.3-.45,2.31.16,2.75s1.1-1.08,1.1-1.08a7,7,0,0,1,3.87.93c-.14.32.17,1.45.81,1.3s1-2.46,1-2.49c0,2.05-.16,3.66-1.38,5-1.55,1.68-4.47.05-5.25-1.34s-.86-2.36-.45-4.46C213.23,197.38,213.27,197.19,213.32,197Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.76,198.83c0,.77-.89.4-.88-.69s.58-3.75.79-5.54c.14-2.58.24-4.28.74-4.25a.22.22,0,0,0,0,.08s-.05,1.46-.06,1.63c-.08,1.57-.1,4.63-.31,6.05A21,21,0,0,0,214.76,198.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.18,199.55a21.4,21.4,0,0,0,.6-2.65c.24-1.41,1.07-4.22,1.48-5.74.13-.25.55-1.66.55-1.66.34.1,0,1.45-.16,2.08s-.35,1.3-.55,2.21c-.51,1.79-.56,4.46-.89,5.49S218,200.29,218.18,199.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.49,199.67l-.07,0a6.65,6.65,0,0,0-3.8-.82.2.2,0,0,1-.22-.14.16.16,0,0,1,.14-.19,7,7,0,0,1,4.07.88.16.16,0,0,1,.07.23A.19.19,0,0,1,218.49,199.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,198.05l-.06,0a8.32,8.32,0,0,0-4.26-.9.21.21,0,0,1-.21-.15.15.15,0,0,1,.15-.18,8.7,8.7,0,0,1,4.5,1,.16.16,0,0,1,.07.23A.19.19,0,0,1,219,198.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.86,195.54a.2.2,0,0,1-.15-.13.14.14,0,0,1,.12-.19,7.2,7.2,0,0,1,4.5.92.15.15,0,0,1,.06.23.19.19,0,0,1-.25,0,7,7,0,0,0-4.2-.87A.21.21,0,0,1,214.86,195.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.06,194.05a.19.19,0,0,1-.15-.12.15.15,0,0,1,.12-.2,6.62,6.62,0,0,1,4.58.92.16.16,0,0,1,0,.24.18.18,0,0,1-.25,0,6.22,6.22,0,0,0-4.27-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.29,192.39a.2.2,0,0,1-.15-.13.14.14,0,0,1,.11-.19,6.86,6.86,0,0,1,4.62,1,.16.16,0,0,1,.06.23.2.2,0,0,1-.26,0,6.45,6.45,0,0,0-4.3-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07,135.6a112.64,112.64,0,0,0-.82,17.82c.09,3.08.42,6.65.41,9.74a17.63,17.63,0,0,1,0,2.72c-.26,1.6-.56,3.22-.87,4.82a28.7,28.7,0,0,0-.52,3.57,37.22,37.22,0,0,1-.28,5.39,16.72,16.72,0,0,0-.41,2,3.08,3.08,0,0,0,.09,1.09c.11.35.4.59.51.91a5.54,5.54,0,0,1,0,1.68s4.12,1.76,6.68.84a6.13,6.13,0,0,1,.4-1.57c.18-.26.61-.41.84-.68a2.27,2.27,0,0,0,.5-1,10.72,10.72,0,0,0,.13-1.5,14.49,14.49,0,0,1,1-3.43c1-3.05.81-6.29,1.43-9.41.84-4.22,1.24-6.89,1.7-9.89s1.8,6,1.8,6a9,9,0,0,1-.07,1.64,30.24,30.24,0,0,1-.13,3.16,22.12,22.12,0,0,0,.26,7,12.61,12.61,0,0,1,.39,3.29,4.24,4.24,0,0,0,.13,2c.21.48.51.6.77,1.05.11.18.13,1.64.24,1.71s4.25,2.15,6.91-.06a5.94,5.94,0,0,1,.16-1.64,2.27,2.27,0,0,0,.77-1.6c.05-.69-.17-1.19-.18-1.88a21.26,21.26,0,0,1,.22-2.51,28.87,28.87,0,0,0,.11-3.6,17.82,17.82,0,0,1-.06-3.18,41.65,41.65,0,0,0,.32-5.24c.15-6.79-.07-20.42-.21-29.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.74,143.76c0,7.09-2.83,9-4.15,9.51C216.59,153.27,219.51,150.11,220.74,143.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,146.6l-2,13.38c.06-.42.13-.83.19-1.25.47-3,1.8,6,1.8,6l-.37-5.86a24.43,24.43,0,0,1,.34-5.47l1.17-5.75a6.82,6.82,0,0,0,4.11-3.19C233.33,146,229.64,146.6,229.64,146.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.11,185.57a8.66,8.66,0,0,0,6.8.83l.46-2a10.51,10.51,0,0,1-7.23-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.26,184.83c.78.79,4.79,1.29,6.92,0l.15-2c-1.61.91-5.73.91-7.31,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3,154.79s.24,8.91.26,9.55,4.75,1.88,4.87,1.48c.21-.68.15-2.18.54-9.41A14.92,14.92,0,0,1,216.3,154.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.24,158.9a1.6,1.6,0,0,0-.44,0l-.52,0a8,8,0,0,1-1.09-.17,8.55,8.55,0,0,1-1.19-.36c-.32-.12-.62-.28-.93-.4,0,0,0,.05,0,.06a4.71,4.71,0,0,0,1,.51,7,7,0,0,0,1,.31,6.72,6.72,0,0,0,1.09.19,5.09,5.09,0,0,0,.55,0,1.14,1.14,0,0,0,.58,0S221.27,158.91,221.24,158.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19,157.69c-.05-.09-.08-.15-.18-.16a.34.34,0,0,0-.24.06.28.28,0,0,0-.12.2.33.33,0,0,0,.17.33.34.34,0,0,0,.34,0,.24.24,0,0,0,.08-.2A.51.51,0,0,0,219.19,157.69Zm-.09.26a.2.2,0,0,1-.24.05c-.12-.07-.1-.31,0-.32a.14.14,0,0,1,.13,0A.19.19,0,0,1,219.1,158Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.36,127.16a8.13,8.13,0,0,0,3.18.9,22.14,22.14,0,0,1,3.89,1.67l.86.4a2.68,2.68,0,0,0,.42.19c.13.05.25.09.24.27a.51.51,0,0,1-.17.34,1.53,1.53,0,0,1-1.18.39,6.69,6.69,0,0,1-1.26-.25c-.33-.07-.17.27-.08.42.47.74,2.83,1.32,3.6,1.71.35.17.81.17.87.63a3.17,3.17,0,0,0,.07.46,1.88,1.88,0,0,0,.27.42,1.13,1.13,0,0,1,.21.69.66.66,0,0,1-.42.55c-.19.05-.4,0-.58.07a1.77,1.77,0,0,0-.22.16c-.34.22-.78.1-1.19.09s-.68.1-1,.1a5.76,5.76,0,0,1-1.1,0,13.34,13.34,0,0,1-2.48-.66,8.79,8.79,0,0,1-2.8-2,5.64,5.64,0,0,0-2.32-1.63c-1.51-.66-7.34-2.92-9.4-4.4a41.35,41.35,0,0,1-3.5-3.57A59.05,59.05,0,0,1,235.6,119l-.46-8.73a6.89,6.89,0,0,1,4.33,2.48c3.07,3.37,7.74,9.08,7.74,9.08S253.32,126.51,254.36,127.16Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.93,110c3,.24,3.85,1.62,5.76,3.64s5.11,5.93,5.11,5.93a15.66,15.66,0,0,1-2.8,3.3,3.84,3.84,0,0,1-3.14,1.13l-4.64-4.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,131.27a3.82,3.82,0,0,1-3.67-.07,3.5,3.5,0,0,0,1.93.91A1.76,1.76,0,0,0,259.35,131.27Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,181.26l9.13,12.51a.47.47,0,0,0,.85-.27l.37-15.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,193.5a.47.47,0,0,1-.85.27l-1.78-2.44h0a2.6,2.6,0,0,0,2.54-1l.17-.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,109.62l.42,1.37.53,1.65,20.4,65.29a7,7,0,0,1-3.74,3.41c-2.43,1-5.26,1-6.61-.09L242.61,116l-1-3.16C242.38,114.86,252.72,111.65,252,109.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.64,114.83l1,3.06c.31.87-1.4,2-3.52,2.91-2.81,1.17-6.47,1.44-6.87.28l-.71-2.26-.23-.81c.4,1.17,4.06.9,6.87-.27,2-.85,3.68-1.95,3.53-2.81h0A.29.29,0,0,0,253.64,114.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87,115.59c.71,2-9.67,5.23-10.38,3.19l-1-3.06c.72,2,11.1-1.15,10.39-3.18Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,109.62l.95,3c.71,2-9.29,5.16-10.34,3.37a.37.37,0,0,1-.05-.11l-.93-3.05C242.38,114.86,252.72,111.65,252,109.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.61,116l-1-3.16c.34.91,2.67.94,5,.3l21.46,68.7,4,11.92L263,181.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.54,99.78a.47.47,0,0,1,0-.1c-.41-1.33,1.58-3.13,4.45-4s5.51-.53,5.93.79h0L252,109.62c.31.87-1.38,2-3.48,2.91-2.8,1.18-6.46,1.47-6.89.32h0l-4-12.86-.05-.17Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,95.88l5.34,17.27c-2.35.61-4.7.61-5-.3h0l-4-12.86-.05-.17v0a.47.47,0,0,1,0-.1C237.11,98.45,238.8,96.81,241.33,95.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.49,99.68c.41,1.33,3.07,1.68,5.94.8s4.85-2.69,4.44-4-3.07-1.68-5.93-.79S237.08,98.35,237.49,99.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-451",
    d: "M224.22,110.48A55.78,55.78,0,0,0,217,112.7s-1.45,1.74-.44,11.12c.14,1.33.25,5.13.38,8.32.08,2.06-.41,4.9-.59,8.77,0,0,5.1,2.41,13.87,1.36,6.89-.83,9.19-3.74,9.19-3.74s-.37-12.06-.76-17.31c-.51-6.9-1.77-9.09-3.72-11.23a29.58,29.58,0,0,0-5.11,0A52.7,52.7,0,0,0,224.22,110.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,117.35a25.83,25.83,0,0,1,.51,4.53A32.12,32.12,0,0,1,225.07,124c0-1.7-.19-3.11-.37-4.72A36.33,36.33,0,0,0,236.14,117.35Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235,93.56a1.76,1.76,0,0,0-.46-1.11,1.81,1.81,0,0,0-2-.42,3.2,3.2,0,0,0-.34-1.43,1.35,1.35,0,0,1-1.27.9,6.07,6.07,0,0,1-1.63-.24,7.64,7.64,0,0,0-5.11.65,6.75,6.75,0,0,0-2.28,1.86,6.84,6.84,0,0,0-.71,1.37,8,8,0,0,0-.25,1.17c-.89.21-1.37,1.42-1.46,2.23a5.2,5.2,0,0,0,.37,2.43c.36,1,.87,1.86,1.31,2.78a22.33,22.33,0,0,0,1.54,2.74c.14.21.77,1.12,1,1.35a1.94,1.94,0,0,0,1.08.42l-.29-2.72-.26-2.35a3.18,3.18,0,0,0,1.82-2.76,4.46,4.46,0,0,0,0-.89l1.26,0c1,0,2,0,3,0a3.79,3.79,0,0,1,1.3.12,1.82,1.82,0,0,0,1,.13A4.07,4.07,0,0,0,235,98.55a3.28,3.28,0,0,0,.72-3.33c-.15-.39-.46-.79-.87-.79A1.73,1.73,0,0,0,235,93.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.71,95.86c.51.65.85,1.43,1.18,3.94.13,1,.33,2,.44,3.21.26,3.07-.25,4.6-1.62,5.34a6.08,6.08,0,0,1-2.27.67l.25,1.92c1.7,1.91-4.66,3.64-7.35.48l-.56-5.57c-.35.61-1.7.72-2.58-.32-1.13-1.33-1.18-2.91-.28-3.6a1.73,1.73,0,0,1,2.82.58c1.06.34,2.17-1.13,1.74-5.09C229.78,98.35,231,94.7,233.71,95.86Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.44,109c-4.5.39-5.79-1.31-6.81-2.9a4.26,4.26,0,0,0,2.61,3.35,12.22,12.22,0,0,0,4.3.33Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.69,105l-2.29-.62a1.13,1.13,0,0,0,.79,1.44A1.25,1.25,0,0,0,231.69,105Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,105.81a1.27,1.27,0,0,1-.51,0,1.1,1.1,0,0,1-.82-.88A1.36,1.36,0,0,1,230.7,105.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.44 99.61 231.26 103.53 233.26 102.56 230.44 99.61",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,98.82l-1.53-.33a.76.76,0,0,1,.91-.61A.81.81,0,0,1,234,98.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.25,99.88l1.24-1a.76.76,0,0,0-1.09-.15A.83.83,0,0,0,227.25,99.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.21,100.72a.65.65,0,0,1-.61.67.64.64,0,0,1-.66-.61.64.64,0,0,1,1.27-.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.71,100.17a.64.64,0,0,1-.61.66.64.64,0,1,1,.61-.66Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M252.13,131.24c-.12.24-.41.32-.51.56a.91.91,0,0,0,0,.37,1.2,1.2,0,0,1-.37.92,1,1,0,0,0-.23.23.81.81,0,0,0-.1.31,2.53,2.53,0,0,1-.79,1.2c-.16.14-.32.27-.5.4a5.1,5.1,0,0,1-.84.49,3.23,3.23,0,0,1-.58.24,14.36,14.36,0,0,1-3.75.5c-1.34,0-2.59-.32-4.7-.21-3.08.16-9.5.29-11.61.25s-3.09-.57-4.92-2.84a71.19,71.19,0,0,1-6.25-9.23c-3.62-6.11-2.74-10.12.17-11.55,2.67.48,3.54,2.11,5.46,5.23,1.69,2.76,7.2,11.64,7.2,11.64s9.51,1,11.17.9a15.63,15.63,0,0,0,4.41-1.25c.43-.15.84-.33,1.27-.48l.48,1.54a2.89,2.89,0,0,1-.25.24c-.19.15-.63.49-.33.74a1.14,1.14,0,0,0,.91.07,2.24,2.24,0,0,0,.37-.1c.31-.09.59-.2.77-.26a15.21,15.21,0,0,1,2.24-.66,1.53,1.53,0,0,1,1.13.15A.43.43,0,0,1,252.13,131.24Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.14,130.49c-.1.13-.22.25-.33.37s-.32.4-.19.46a1,1,0,0,0,.79,0l.51-.16a11.86,11.86,0,0,1,2.92-.71c-1,.31-1.87.72-2.82,1a3.8,3.8,0,0,1-.51.14,1.84,1.84,0,0,1-.66,0c-.33,0-.69-.36-.44-.69a5.78,5.78,0,0,1,.71-.6Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.8,129.74c2.81.15,5.75.42,8.56.62.71,0,1.42.11,2.13.14a11.34,11.34,0,0,0,4.12-.9l2-.68c-2,.79-4,1.91-6.16,1.88a100.49,100.49,0,0,1-10.69-1.06Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,112.7c-2.44,1.14-3.19,2.92-2.47,6.35a22.88,22.88,0,0,0,3.37,7.65c1,1.58,1.83,2.87,1.83,2.87A10.42,10.42,0,0,0,224,127.9a6.36,6.36,0,0,0,2.65-3.34s-2.46-4.43-3.59-6.23S220,112.55,217,112.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.13,131.24c-.12.24-.41.32-.51.56a.91.91,0,0,0,0,.37,1.2,1.2,0,0,1-.37.92,1,1,0,0,0-.23.23.81.81,0,0,0-.1.31,2.53,2.53,0,0,1-.79,1.2c-.16.14-.32.27-.5.4a5.1,5.1,0,0,1-.84.49l-1.32-4.21a2.24,2.24,0,0,0,.37-.1c.31-.09.59-.2.77-.26a15.21,15.21,0,0,1,2.24-.66,1.53,1.53,0,0,1,1.13.15A.43.43,0,0,1,252.13,131.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.14,
    y1: 130.49,
    x2: 247.12,
    y2: 130.42,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.84,130.49c-1,.31-1.87.72-2.82,1a3.8,3.8,0,0,1-.51.14l-.1-.31.51-.16A11.76,11.76,0,0,1,250.84,130.49Z",
    style: {
      opacity: 0.1
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M310.66,233.26c8.44,4.93,8.44,12.91,0,17.84s-22.1,4.92-30.54,0-8.43-12.91,0-17.84S302.23,228.34,310.66,233.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.32,215c-.07,1.26-.11,2.58-.14,3.83-.4,7,.15,10.49-.21,15a81.75,81.75,0,0,0-.58,8.34c.23,2.67,3.88,2.63,4.23,1.08s1.19-8.31,1.28-9c.28-2.89,1.93-7,3.05-12.75.45-2,1-4.23,1.54-6.5Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.61,233.59c-.76-.75-.93-1.46-.8-3.24,0-.34.53-7.67,1.07-15.36h-9.47c.3,3.78,3,15.59,3,16.56a1.6,1.6,0,0,1,0,.31c0,1.7,2.11,2.6,3.75,3.71a30,30,0,0,0,4.41,2.6c1.18.54,3.57.56,3.86-.14A44.44,44.44,0,0,1,305.61,233.59Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,239.83a1.38,1.38,0,0,1-.28,1.47,7.2,7.2,0,0,1-4.94,1.09,9,9,0,0,1-4.79-1.71,10.57,10.57,0,0,0-3.49-2,7.12,7.12,0,0,1-2.5-.91c-.33-.29-.3-1.61-.3-1.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.36,231.07s-.19,0-.25.32-.14,1.41-.3,2a10,10,0,0,0-.2,3.19c.14.67,1.83,1.12,2.91,1.48a14.5,14.5,0,0,1,3.51,2,10.67,10.67,0,0,0,5.2,1.74c2.45,0,4-.62,4.5-1.44.59-1,.11-1.59-2.71-2.76-.53-.23-2.41-1.23-3-1.59a15.15,15.15,0,0,1-1.93-1.3c-.3-.25-.59-.5-.87-.78a3.77,3.77,0,0,1-.72-.83c0-.07-.05-.15-.08-.22a2.54,2.54,0,0,1-.19-.61c-.05-.21-.08-.53-.31-.65a1.87,1.87,0,0,0-1-.1,7.8,7.8,0,0,0-1.08.15c-.42.09-.89.13-1.13.49a1.72,1.72,0,0,0-.22.94c0,.15,0,.31,0,.46s0,.18-.07.15-.2-.25-.24-.32-.13-.35-.22-.52a3.19,3.19,0,0,0-.35-.55,2.92,2.92,0,0,0-.45-.41c-.16-.11-.35-.16-.49-.28A1,1,0,0,1,299.36,231.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,237.8c-3.54.26-4.63,2.29-4.77,3.55a9.18,9.18,0,0,0,2.52.46c2.45,0,4.12-.62,4.6-1.44S315,238.66,312.48,237.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.17,237.89a.15.15,0,0,1-.11,0,.15.15,0,0,1,0-.22,4.26,4.26,0,0,1,3.18-1.2.16.16,0,0,1,.16.17.18.18,0,0,1-.19.15,4,4,0,0,0-2.88,1.08A.2.2,0,0,1,307.17,237.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.64,237.08a.2.2,0,0,1-.11,0,.15.15,0,0,1,0-.23,4.34,4.34,0,0,1,3.19-1.2.17.17,0,0,1,.15.18.17.17,0,0,1-.19.14,4,4,0,0,0-2.88,1.08A.16.16,0,0,1,305.64,237.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.22,236.16a.15.15,0,0,1-.11,0,.14.14,0,0,1,0-.22,4.3,4.3,0,0,1,3.19-1.2.16.16,0,0,1,.15.17.18.18,0,0,1-.19.15,4,4,0,0,0-2.88,1.08A.16.16,0,0,1,304.22,236.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.82,235.23a.23.23,0,0,1-.11,0,.17.17,0,0,1,0-.23,4.46,4.46,0,0,1,3.48-1.21.15.15,0,0,1,.16.17.16.16,0,0,1-.19.14,4.11,4.11,0,0,0-3.17,1.1A.2.2,0,0,1,302.82,235.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.77,244.44a6.82,6.82,0,0,1-.95,3.48,2.56,2.56,0,0,1-2.84.92c-1.13-.26-2.58-1-2.91-2.3a7.86,7.86,0,0,1-.25-3.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,233.27c-.46,0-.6,2.1-.87,4.18s-1,3.14-1.26,5a5.32,5.32,0,0,0,.86,4.27c.79,1.26,3.59,2.5,5,.69,1.12-1.47,1.16-3.1,1.06-5.18a45.05,45.05,0,0,1,.15-5.27c.09-1.56.47-3.14.06-3.31,0,.23-.06.52-.09.75a4,4,0,0,1-.15.83c-.05.11-.16.23-.2.05a1.27,1.27,0,0,1,0-.39c.07-.58-.24-.62-.41-.67-.37-.09-1.81-.26-2.16-.28a4.84,4.84,0,0,0-1.75.11,1.28,1.28,0,0,0-.16.61c0,.31-.11.54-.12.44a7.07,7.07,0,0,1,0-.95c0-.13,0-.32,0-.45S281,233.4,281,233.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.75,243.62a4.9,4.9,0,0,0,.87,3.17c.79,1.26,3.81,2.5,5.18.7a5.62,5.62,0,0,0,1-3.05C284.94,243.05,280.05,242.44,278.75,243.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.75,242.18l-.06,0a8.61,8.61,0,0,0-4.27-.38.17.17,0,0,1-.21-.12.16.16,0,0,1,.13-.19,8.75,8.75,0,0,1,4.5.4.15.15,0,0,1,.08.22A.19.19,0,0,1,284.75,242.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.52,240.23a.18.18,0,0,1-.14-.11.15.15,0,0,1,.1-.2,7.19,7.19,0,0,1,4.5.37.14.14,0,0,1,.07.21.18.18,0,0,1-.23.07,7,7,0,0,0-4.22-.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.6,238.76a.15.15,0,0,1-.15-.1.17.17,0,0,1,.1-.21,6.61,6.61,0,0,1,4.59.36.15.15,0,0,1,.05.22.16.16,0,0,1-.23.05,6.39,6.39,0,0,0-4.29-.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.71,237.32a.17.17,0,0,1-.14-.1.16.16,0,0,1,.1-.21,6.92,6.92,0,0,1,4.61.4.16.16,0,0,1,.06.22.16.16,0,0,1-.23.06,6.61,6.61,0,0,0-4.32-.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,175.25c-2.09,3.54-3.65,6.42-3.86,16.94s-.18,11.21-.23,12.48-.31,2.54-1,8.79a83.54,83.54,0,0,0-.15,13.4s.78,1.38,3.36,1.59a5.22,5.22,0,0,0,3.54-.72s3.27-12.16,4.17-15.92,3-12.9,3-12.9l1.26,8.13a28.91,28.91,0,0,0,0,8.93,71,71,0,0,0,1.66,8.85,18.82,18.82,0,0,0,4.27.55,7.7,7.7,0,0,0,3.41-.81s1.55-14,1.55-20.23-.27-19.82-2.38-29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.86,198.91,297,187s4.49-.3,7-2.71c-1,2.56-4.69,4.36-6.31,4.72l-1.9,9.79.37,8.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.06,206c.77-2.79,1.11-2.73,1.17-10.5.07-8.37,1.14-13.82,3.67-18.79l.34.15a30.84,30.84,0,0,0-3,9.77,3.11,3.11,0,0,0,2.35-.18c1-.56,1.66-1.88,2.07-3.91,1-4.89,2.06-6.47,2.11-6.54l.31.19s-1.11,1.61-2.06,6.41c-.43,2.16-1.16,3.52-2.23,4.14a2.86,2.86,0,0,1-1.47.38,4.67,4.67,0,0,1-1.13-.15,62.8,62.8,0,0,0-.56,8.54c-.07,7.81-.42,7.76-1.18,10.57-.15.52-.29,1-.42,1.57-.82,3.29-1.7,12.71-1.24,20.14a2.92,2.92,0,0,1-.39-.26c-.42-7.41.45-16.69,1.27-20C282.78,207,282.92,206.49,283.06,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.6,187.64c.07.67,1.42,14.5,1,17.86-.09.79-.2,1.54-.31,2.25a40,40,0,0,0-.44,9.5c.25,4.16.63,5.9.67,8l-.37-.05c0-2.15-.43-3.84-.67-8a39.87,39.87,0,0,1,.44-9.55c.11-.72.22-1.46.31-2.25.38-3.32-1-17.62-1-17.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.31,165.29c-.77.76-1,.82-2.71.94a7.94,7.94,0,0,0-1.76.24c-1.18.52-4.19,1.78-4.19,1.78l-.13-5.76,3.21-.75c1-.25,4.33-3.69,5.11-3.71a1.82,1.82,0,0,1,1.9,1.48C331,160.6,330.23,164.4,329.31,165.29Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.91,154c3.75.65,4.31,1.18,6.32,3.44,2.5,2.81,6.32,7,6.32,7l11.18-2.62c-.63.74-1.81,2.94,1.11,4.73-2,.89-8.72,3.67-11.17,4.51-2,.69-2.83.73-4.72-.91-2.49-2.15-7.3-6.83-7.3-6.83Z",
    style: {
      fill: "#9e6767"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-451",
    d: "M283.59,179.81c.32-1.32,1.29-5.26,1.39-6,.6-4.46-.72-5.77-.72-10.12s1.19-8.41,2.18-9.25c0,0,1.12-.28,2.06-.45.75-.13,1.33-.22,2.31-.46a16.84,16.84,0,0,1,6.08.09,9.62,9.62,0,0,1,1.91.13c.66.16,2.2.42,2.2.42a23.94,23.94,0,0,1,4,5.72c1,2,1,3.3.65,6.51a42.2,42.2,0,0,0-.09,6c.11,3.34.22,4.9.4,7.45C301.59,182.48,289.21,183.08,283.59,179.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-451",
    d: "M293.23,153.74a19.42,19.42,0,0,1,3,.26l.64.08a2.82,2.82,0,0,0,.42,0h.32a4.65,4.65,0,0,1,1.12.11c.37.09,1.07.22,2.06.4a23,23,0,0,1,3.79,5.47c.92,1.91.9,3.16.6,6.24a43.7,43.7,0,0,0-.08,6.06c.1,3.26.21,4.88.37,7.15-2.22,1.23-6.41,2-10.84,2-4.27,0-8-.73-10.42-2l.07-.3c.55-2.29,1.15-4.78,1.23-5.41a16.11,16.11,0,0,0-.25-5.87,22.21,22.21,0,0,1-.46-4.32c0-4.18,1.13-7.95,1.92-8.8.32-.07,1.18-.28,1.91-.41l.37-.06c.59-.11,1.14-.2,2-.4a9.59,9.59,0,0,1,2.3-.25m0-.5a10.67,10.67,0,0,0-2.42.26c-1,.24-1.56.33-2.31.46-.94.17-2.06.45-2.06.45-1,.84-2.18,5-2.18,9.25s1.32,5.66.72,10.12c-.1.77-1.07,4.71-1.39,6,2.67,1.55,6.87,2.23,11,2.23,4.57,0,9.07-.83,11.36-2.23-.18-2.55-.29-4.11-.4-7.45a42.2,42.2,0,0,1,.09-6c.31-3.21.31-4.52-.65-6.51a23.94,23.94,0,0,0-4-5.72s-1.54-.26-2.2-.42a5.19,5.19,0,0,0-1.23-.12h-.68a26.6,26.6,0,0,0-3.66-.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.29,142.47a1.94,1.94,0,0,1,0-1.92,2.29,2.29,0,0,1,1.39-.74,1.22,1.22,0,0,0,1.06-1.35,2.41,2.41,0,0,1,1-2,4.38,4.38,0,0,1,4.56-.09l3.62,11.84c-.78.78-.94,1.34-1.39,1.58s-1,.07-1.39.28a3.79,3.79,0,0,0-.69.58,1.71,1.71,0,0,1-1.84.15c-.49-.27-.83-.79-1.36-1-.77-.26-1.61.29-2.39.07a.73.73,0,0,1-.43-.27c-.28-.41.13-1,.05-1.48a1.34,1.34,0,0,0-.48-.72,2.43,2.43,0,0,1-.6-.64.66.66,0,0,1,.09-.81.76.76,0,0,0-.56.66,2.38,2.38,0,0,0,.12.91,2,2,0,0,1-1-1.25,2,2,0,0,1,.31-1.56c.2-.28.49-.54.51-.89C282.9,143.25,282.59,143,282.29,142.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.39,136.43c-1.72.11-2.86,2.82-1.7,4.75S291.06,136.12,288.39,136.43Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,137.27c-.22-2.12-2.59-2.3-3.22-2.26a3,3,0,0,1-2.4-1.12,3,3,0,0,0-2.87-1c-1.71.37-1.34,1.09-2.79,1.51-1.29.38-2.22-.08-3.42,1a3.27,3.27,0,0,0-1,2.73c-.89.5-2.18,3.65-.55,7.23.85,1.84,1.91,2.73,3.23,4.28l1.33.06c.48-1.11,1.6-.85,2.64-1.07.68-.27,1.08-1,1.76-1.27s1.46,0,2.19-.11a4.11,4.11,0,0,1,1.73-.22c1.31.6,3.37-.48,3.28-2a4.79,4.79,0,0,1-.16-1.39c.14-.6.8-.91,1.16-1.4a1.62,1.62,0,0,0,0-1.94C303.75,139.21,303.87,138.47,303.75,137.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.67,152.39c0-.7,0-4.14,0-4.14A1.76,1.76,0,0,1,288,148a3,3,0,0,1-.34-3.76c.74-1,2.41-1,3.09.67.51,0,1.31-.1,1-2.69,0-3.14,3-5.74,5.61-3.57,1-1.76,3.11-1.07,3.89.64a5.41,5.41,0,0,1,.37,3.46,13.5,13.5,0,0,1,.35,2.58c-.09,3.76-1,5.08-2.18,5.64a5.71,5.71,0,0,1-2.72.51v1s-.07.83.5,1c.38.12,1.14.28,1.14.28s2.94,3.54-2.22,3.84a9.32,9.32,0,0,1-8.08-3.6,10.45,10.45,0,0,0,1.16-.23C290.56,153.52,290.67,153.08,290.67,152.39Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.77,146.8l2,.6a1,1,0,0,1-1.26.71A1.07,1.07,0,0,1,295.77,146.8Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.9,147.24a1.14,1.14,0,0,1,1.13.87,1,1,0,0,1-.57,0,1.06,1.06,0,0,1-.71-.85Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.07,141.52l-1.4-.72a.76.76,0,0,1,1-.36A.84.84,0,0,1,301.07,141.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,141.78l1.35-.84a.76.76,0,0,0-1.07-.27A.83.83,0,0,0,294,141.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.51,143.15a.68.68,0,0,0,.61.71.64.64,0,0,0,.7-.59.69.69,0,0,0-.61-.71A.64.64,0,0,0,299.51,143.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.77,143.31a.66.66,0,0,0,.61.7.61.61,0,0,0,.69-.58.67.67,0,0,0-.61-.71A.63.63,0,0,0,294.77,143.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.97 145.29 297.9 146.3 297.45 142.31 299.97 145.29",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.16,151.45c-2.26,0-4.66-.91-5.72-3.14a3.83,3.83,0,0,0,1.17,2.55,7.54,7.54,0,0,0,4.55,1.4Z",
    style: {
      fill: "#874c4c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.54,164.51a7.6,7.6,0,0,1,2.52-1.22c.58-.12,2.64-.79,3.42-.92.49-.08.63.71,0,1.19a16.67,16.67,0,0,1-2.36,1.06,9.69,9.69,0,0,0-1.73,1.46Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.36,157.48c1.42-2.48,1.95-2.41,5.08-3.07,2.53,2.91.44,9.08.44,9.08l-2.82,6.81s7.45-1.37,8.32-1.83a49.69,49.69,0,0,0,4.07-3.32c1.09-.89,1.58-.72,2.09-.6a5.62,5.62,0,0,1,2.35.82.76.76,0,0,1,.28.68c.44.09,1.11.13,1.14.87a2.69,2.69,0,0,1,0,.59.49.49,0,0,1,.27.19c.34.46-.42,1.9-.85,2.23a1.49,1.49,0,0,1-1.24.12c-.45-.1-.2-.55-.2-.55h-.64c-1.44.86-1.67,2.78-3.51,3.06a12,12,0,0,0-2.24.25c-4,1-10.7,4.44-14.2,4.46s-3.16-1.78-3.05-3.86C276.73,171.55,280,160,281.36,157.48Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.26,169.6l-.2.7c-1.57.27-3.33,1.25-3.77,2.06C280.69,171.05,281.49,170.11,284.26,169.6Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.17,166.05l-2-.57,1.95.29A.88.88,0,0,1,301.17,166.05Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.29,167.51,300,167l2.3.21A2.45,2.45,0,0,1,302.29,167.51Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,168.5a.73.73,0,0,1-.33.24,1.12,1.12,0,0,1-.4.1l0,0c-.07.12-.15.23-.22.34l-.05-.06a.45.45,0,0,1,.36.12.58.58,0,0,1,.18.31.7.7,0,0,0-.22-.26.43.43,0,0,0-.3-.09h-.09l0-.07.23-.34v0h0a1.8,1.8,0,0,0,.39-.08A1,1,0,0,0,301.9,168.5Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.27,168.74a7.49,7.49,0,0,1-.84,0s0,.16-.32.41a4.92,4.92,0,0,1-.48.34h.64a1,1,0,0,1,.75-.33Z",
    style: {
      fill: "#874c4c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.88,153.33h.3l.32,0,.28,0,.12,0,.17-.05a8.9,8.9,0,0,0,4.06-2.63c3.2-3.37,4.72-8.48,3.4-11.41a3.11,3.11,0,0,0-2.46-1.94l-.12,0h-.25a5,5,0,0,0-2.21.47c0,.27,0,.55,0,.85a13.85,13.85,0,0,1-6.26,10.86q-.39.22-.75.39a5.58,5.58,0,0,0,.43,1.63A3.13,3.13,0,0,0,328.88,153.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,157c-.11-.17-.41-.16-.67,0s-.63.41-.94.6l3.29,1.9h0a.16.16,0,0,1-.07-.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.19,163.72l1-4.47a.51.51,0,0,0-.32-.56,4.92,4.92,0,0,1-1.36-.8.58.58,0,0,0-.7.12l-3.19,2.92a.53.53,0,0,1-.35.16l5.07,2.93A.26.26,0,0,1,324.19,163.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.83,140.83l2.68.15a.46.46,0,0,1,.2.05l-3.26-1.89c0,.41,0,.83-.07,1.25A.44.44,0,0,0,342.83,140.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.14,161.06a.2.2,0,0,0,.11,0l-.09-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,161l-1.42-3.14a.8.8,0,0,1,.18-.74l3-3.62a1.31,1.31,0,0,0,.29-.79,13.89,13.89,0,0,1,0-2.58.43.43,0,0,0-.45-.44L318,149.5a.35.35,0,0,1-.36-.45l1.48-5a1,1,0,0,1,.66-.55l2.93-.7a1.24,1.24,0,0,0,.75-.56,25.66,25.66,0,0,1,1.57-2.73,1.11,1.11,0,0,0,.18-.78l-1-3.23a.89.89,0,0,1,.27-.75l3.42-3.62c.21-.22.47-.25.58-.08l1.6,2.44c.11.17.4.16.67,0a14.31,14.31,0,0,1,1.93-1.12,1.37,1.37,0,0,0,.68-.66l1.69-4.53a.87.87,0,0,1,.69-.48l3.12-.31a.52.52,0,0,1,.29,0,.29.29,0,0,1,.14.32l-1,4.46a.52.52,0,0,0,.32.56,4.83,4.83,0,0,1,1.37.8.59.59,0,0,0,.7-.12l3.19-2.92a.43.43,0,0,1,.46-.14l-6.3-3.64a.21.21,0,0,0-.12,0l-5.06-2.93a.49.49,0,0,0-.31-.06l-3.12.31a.87.87,0,0,0-.68.47l-1.69,4.54a1.5,1.5,0,0,1-.68.66c-.33.16-.66.33-1,.52l-3.27-1.89c-.13-.09-.34,0-.51.15l-3.43,3.62a.91.91,0,0,0-.26.75l1,3.23a1.1,1.1,0,0,1-.17.78,25.75,25.75,0,0,0-1.58,2.73,1.23,1.23,0,0,1-.74.56l-2.93.7a1,1,0,0,0-.67.56l-1.47,5a.3.3,0,0,0,.11.36c.06.06,3.32,1.93,3.32,1.93,0,.45,0,.9.06,1.33a1.33,1.33,0,0,1-.29.79l-3,3.62a.8.8,0,0,0-.17.74l1.42,3.14a.21.21,0,0,0,.08.1l6.3,3.65A.21.21,0,0,1,319,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.85,122.81a.48.48,0,0,0-.31-.06l-3.12.31a.94.94,0,0,0-.52.25l6.31,3.64a.93.93,0,0,1,.51-.24l3.13-.31a.54.54,0,0,1,.29,0C339,126.34,333,122.88,332.85,122.81Zm-10.75,4.55c-.13-.09-.34,0-.51.15l-3.43,3.62a1,1,0,0,0-.24.43l6.31,3.61a1.06,1.06,0,0,1,.24-.39l3.42-3.62c.17-.17.36-.23.49-.16Zm-3,16.72a.6.6,0,0,1,.13-.21l-6.32-3.63a.62.62,0,0,0-.11.19l-1.47,5a.3.3,0,0,0,.11.36l.05,0,3.25,1.88h0l3,1.75a.33.33,0,0,1-.15-.39ZM319,161l-1.42-3.14a.47.47,0,0,1,0-.37l-6.31-3.65a.58.58,0,0,0,0,.37l1.42,3.14a.3.3,0,0,0,.09.1h0l6.27,3.63A.16.16,0,0,1,319,161Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.72,141h0a.46.46,0,0,0-.2-.05l-2.68-.15a.44.44,0,0,1-.45-.44c0-.42.06-.84.07-1.25s0-.9-.06-1.33a1.27,1.27,0,0,1,.29-.79l3-3.62a.83.83,0,0,0,.18-.74l-1.42-3.14a.22.22,0,0,0-.09-.1h0a.43.43,0,0,0-.46.14l-3.19,2.92a.59.59,0,0,1-.7.12,4.83,4.83,0,0,0-1.37-.8.52.52,0,0,1-.32-.56l1-4.46a.29.29,0,0,0-.14-.32.52.52,0,0,0-.29,0l-3.12.31a.87.87,0,0,0-.69.48l-1.69,4.53a1.37,1.37,0,0,1-.68.66,14.31,14.31,0,0,0-1.93,1.12c-.27.18-.56.19-.67,0l-1.6-2.44c-.11-.17-.37-.14-.58.08l-3.42,3.62a.89.89,0,0,0-.27.75l1,3.23a1.17,1.17,0,0,1-.18.78,25.66,25.66,0,0,0-1.57,2.73,1.24,1.24,0,0,1-.75.56l-2.93.7a1,1,0,0,0-.66.55l-1.48,5a.35.35,0,0,0,.36.45l2.68.15a.43.43,0,0,1,.45.44,13.89,13.89,0,0,0,0,2.58,1.31,1.31,0,0,1-.29.79l-3,3.62a.8.8,0,0,0-.18.74L319,161a.21.21,0,0,0,.08.1h0a.2.2,0,0,0,.11,0h0a.53.53,0,0,0,.35-.16l3.19-2.92a.58.58,0,0,1,.7-.12,4.92,4.92,0,0,0,1.36.8.51.51,0,0,1,.32.56l-1,4.47a.26.26,0,0,0,.13.3h0a.51.51,0,0,0,.29.05l3.12-.31a.85.85,0,0,0,.68-.47l1.7-4.54a1.41,1.41,0,0,1,.68-.66c.33-.16.66-.33,1-.52s.63-.39.94-.6.56-.19.67,0l1.6,2.44a.16.16,0,0,0,.07.07c.13.08.33,0,.5-.15L339,155.7a.91.91,0,0,0,.26-.75l-.95-3.23a1,1,0,0,1,.18-.77,26.83,26.83,0,0,0,1.57-2.74,1.23,1.23,0,0,1,.75-.55l2.93-.71a1,1,0,0,0,.66-.55l1.48-5A.34.34,0,0,0,345.72,141Zm-15.65,12.13-.17.05-.12,0-.28,0-.32,0h-.3a3.13,3.13,0,0,1-2.94-2,5.58,5.58,0,0,1-.43-1.63,6.85,6.85,0,0,1,0-.91,13.91,13.91,0,0,1,3.87-8.87A10.6,10.6,0,0,1,331.7,138a7.33,7.33,0,0,1,.79-.4,5,5,0,0,1,2.21-.47H335l.12,0a3.11,3.11,0,0,1,2.46,1.94c1.32,2.93-.2,8-3.4,11.41A8.9,8.9,0,0,1,330.07,153.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.29,158.84c.38-.84.31-.93-.05-1.25a2.36,2.36,0,0,0-2.08-.59,4.92,4.92,0,0,0-1.6.51c-.3.24.12.88,1,.9,1.39,0,1.45.4,1.45.4a17.2,17.2,0,0,0-1.78,0,12.76,12.76,0,0,0-1.89.68c-.54.2-.51.95.49,1l-1,.37c-.7.26-.87.69-.21,1a1,1,0,0,0,.7.12s-.77.15-.73.41c.1.73.61.83,2.25,1a2.36,2.36,0,0,1,1.62.62l-.17,1.24s.91-.85,1.37-1.32a1,1,0,0,0,.31-1.28s.84-.15.79-.69a2.64,2.64,0,0,0-.43-1.07.94.94,0,0,0,.29-1,1.5,1.5,0,0,0-.49-.86Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.84,160.54a4.49,4.49,0,0,1,.92-.29,3,3,0,0,1,1,.11,11.61,11.61,0,0,1,1.8.54,11.42,11.42,0,0,1-1.86-.27,4.29,4.29,0,0,0-.89-.16C327.48,160.48,327.16,160.54,326.84,160.54Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.34,162.05a2.14,2.14,0,0,1,1-.24,5.69,5.69,0,0,1,1,.11,10.2,10.2,0,0,1,1.95.59c-.68-.06-1.34-.19-2-.31A5.05,5.05,0,0,0,326.34,162.05Z",
    style: {
      fill: "#874c4c"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M345.75,295.72c8.89,5.13,23.31,5.13,32.2,0s8.9-13.46,0-18.59-23.31-5.14-32.2,0S336.86,290.59,345.75,295.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-451"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367.81 283.81 369.14 283.24 367.88 282.81 367.81 283.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.54,286.94s-14.92-7.81-15.17-6.79a1.71,1.71,0,0,0,0,.63l0-.06.17,1.95a4.56,4.56,0,0,0,2.33,1.14c0-.09,0-.67.07-1a8,8,0,0,1,1.31.8,14.66,14.66,0,0,1,2.48,3.27c.7,1,2,1.54,4,1.94s4.06.12,4.63-.43A1.57,1.57,0,0,0,380.54,286.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.14,286.48c-.14-.17-.65-.8-1.35-1.5a27.28,27.28,0,0,0-2.1-2,19.92,19.92,0,0,1-1.76-1.92,17.45,17.45,0,0,1-1.88-3.16,6.78,6.78,0,0,1-.23-3.16c.17-2.78.28-3.4.42-5.52l-7.74-.51c.15,1.18.48,2.84.64,4.44.21,2,.86,2.26,0,4.24a5.84,5.84,0,0,0-.7,1.77,2.88,2.88,0,0,0,1.52,2.53c.73.46,1.58.69,2.29,1.18a7.6,7.6,0,0,1,1.8,2,7.37,7.37,0,0,0,1.54,2,6.87,6.87,0,0,0,2.45,1,13.74,13.74,0,0,0,3.34.36C379.93,288.18,381.15,287.67,380.14,286.48Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,285.38c-.63-.6-1.52-1.45-2.59-2.41a2.88,2.88,0,0,0-2.39.08,5,5,0,0,0-2.83,2.76,3.27,3.27,0,0,0,1.77,1.74c2.56,1.3,7.28,1.2,7.4,0C380.75,286.76,380.08,286.1,379.32,285.38ZM366.27,277s-.18.39-.62,1.15a2.2,2.2,0,0,0-.11,2.35,3.49,3.49,0,0,0,2.21,1.7A4.85,4.85,0,0,0,366.27,277Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.12,278.88c.39.7-.36,4.13-.4,5.9s0,4.51-.7,6.05c-.78,1.81-2.23,3.87-4.46,1.89a6.21,6.21,0,0,1-2.13-5.06c0-1.61.85-3.77,1.6-5.68.88-2.24,1.24-3.44,1.24-3.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,267.63c-.47,3.73-.48,5.86-.64,8.26a33.09,33.09,0,0,1-.59,3.73c-.33,1.53-1,3.58-1.3,4.55a5.83,5.83,0,0,0-.38,3.81,1.78,1.78,0,0,0,.14.36c.61,1.35,2.36,2.49,3,2.39a1.08,1.08,0,0,0,1,.44l.2,0,.2-.05a1.93,1.93,0,0,0,1.07-1.09q.06-.15.12-.33a12.54,12.54,0,0,0,.57-3.88c0-.88.16-2.4.36-3.8s1.25-5.21,1.82-7.31c.48-1.73,1.41-5.29,1.41-5.29Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,285.94c1.49-.45,5.78-.07,6.29,1.89a5.94,5.94,0,0,1-1.65,4.35c-1.77,1.91-3.69-.47-4.38-1.94A6.72,6.72,0,0,1,346,285.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.28,218.38a39.35,39.35,0,0,0-3.15,15.46c-.31,10.24-.79,13.94-.89,15.17-.17,2.1-1.08,4-2.05,10.05s-.46,17.11-.46,17.11a7.28,7.28,0,0,0,3.74,1.74,3.81,3.81,0,0,0,3.06-.52s4.06-16.33,5.08-19.94,4.07-15.51,4.07-15.51l1.2,10a22,22,0,0,0-.85,8.51c.35,5.36,2.24,15.4,2.24,15.4a5.5,5.5,0,0,0,3.44.76,5.58,5.58,0,0,0,3.22-.91s2.07-19.91,2.41-25.94,1.19-21.93-1-31.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,230.45l-2.57,11.49,1.2,10-.39-10.08,2.25-9.43c1.48-.26,4.89-1.82,5.94-4.26C370.3,230.39,366.25,230.45,366.25,230.45Zm-6.41-7.18c.31-1,.63-1.91,1-2.87a14.35,14.35,0,0,0-1.46,2.7,24.74,24.74,0,0,0-1,2.88c-.29,1-.54,2-.73,3a19.42,19.42,0,0,0-.37,3c.3-1,.58-1.95.86-2.92s.56-2,.85-2.91S359.53,224.23,359.84,223.27Zm-1.42-.81c.36-.58.72-1.16,1.06-1.77a11.34,11.34,0,0,0-1.47,1.47,15.29,15.29,0,0,0-1.22,1.68,13,13,0,0,0-1,1.85,7.77,7.77,0,0,0-.58,2l1-1.78c.35-.58.69-1.16,1.06-1.73S358.06,223,358.42,222.46ZM355,261.14c-.74,3.11-1.45,6.24-2.11,9.37.91-3.07,1.77-6.15,2.6-9.24s1.63-6.18,2.43-9.29,1.32-6.27,1.81-9.44.91-6.33,1.28-9.51c-.62,3.14-1.2,6.29-1.77,9.43s-1.19,6.28-2,9.37S355.73,258,355,261.14Zm18.19-14.77c0,1.39,0,2.79-.06,4.15s-.24,2.77-.37,4.15l-.4,4.16q-.41,4.16-.7,8.33.68-4.12,1.2-8.27c.35-2.77.69-5.53.91-8.33s0-5.59-.12-8.38-.34-5.56-.65-8.34l.15,8.36C373.15,243.59,373.18,245,373.18,246.37Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.36,196.15c.43-.09.51.32.24.62-.63.72-1.8.67-2.36,1-.13.09-1.69,1.49-1.74,1.92.44-.19,1.78-.9,2.22-1.06a14.69,14.69,0,0,1,1.64-.31,1.51,1.51,0,0,1,.59-.05c.13,0,.27.33,0,.61-.45.51-1.26.48-1.89.73a3,3,0,0,0-1.56,1.12,7.12,7.12,0,0,1,3-.07c.16,0,.19.11.18.21a.57.57,0,0,1-.32.43,5.48,5.48,0,0,1-1.6.2,4,4,0,0,0-1.79.78,1.74,1.74,0,0,0-.48.53,6.79,6.79,0,0,0-.37.83,3,3,0,0,1-2.95,1.71.48.48,0,0,1-.23-.07.42.42,0,0,1-.11-.38,12.32,12.32,0,0,1,1.25-3.91c.16-.42,1.47-3.55,1.54-3.66s3.32-.89,3.43-.9C393.35,196.36,394,196.23,394.36,196.15Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.56,201.4c.61,1,3.25,5.45,3.25,5.45s5.39-2.62,6.72-3.39a7.8,7.8,0,0,0,3.22-3.67c.73-1.63,1-1.72,1.78-2.22.48-.31,1.58-1.19,1.62-1.22a1.56,1.56,0,0,1,.57-.21l.64-.15,1.6-.32a2.62,2.62,0,0,1,.56-.09.17.17,0,0,1,.12,0c.07,0,.07.14.05.21a1.33,1.33,0,0,1-.69.85,5,5,0,0,1-1.06.39c-.22.06-.35.08-.8.21a1.14,1.14,0,0,0-.47.31,13.07,13.07,0,0,0-1.76,2.06A4.49,4.49,0,0,0,391,198.5c.54-.53,1,.16.52,1s-1.44,1.11-2.18,2.42.32,2.62-1.39,3.67a25.16,25.16,0,0,0-2.9,2.23c-1.49,1.27-5.46,4.13-6.45,4.82-2.1,1.47-3.38,1.31-6.19-2.18-3.72-4.61-4.2-5.16-4.2-5.16l.05-8.28C370.71,197.43,371.57,198.22,373.56,201.4Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,199.64a5.16,5.16,0,0,0-1.24.69c-.14.12-.09-.31.51-.76s1.11-.4,1.25-.61Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.73,186.88c2.9-4-.13-8.19-3.87-9.3-5.53-1.63-10.52.3-12.05,5.49-1,3.26-.27,20.55-.27,20.55h16.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.15,223.62c.83-3.52,1.91-5.75,1.85-6.52a74.82,74.82,0,0,0-1.88-9.6c-.93-4.19-.18-7.84.75-8.74,0,0,2.18-.58,3.39-1,.72-.23,1.9-.46,3-.7a17.17,17.17,0,0,1,4.43-.54c.47,0,2.66.24,2.66.24.67.11,1.89.24,1.89.24a14.06,14.06,0,0,1,3.17,3.54c1.21,1.84,1.93,3.4,2.41,7.5.6,5.21,1.34,11,1.59,14.68C371.28,225.73,358,226.49,352.15,223.62Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.15,223.62c.83-3.52,1.91-5.75,1.85-6.52a74.82,74.82,0,0,0-1.88-9.6c-.93-4.19-.18-7.84.75-8.74,0,0,2.18-.58,3.39-1,.72-.23,1.9-.46,3-.7a17.17,17.17,0,0,1,4.43-.54c.47,0,2.66.24,2.66.24.67.11,1.89.24,1.89.24a14.06,14.06,0,0,1,3.17,3.54c1.21,1.84,1.93,3.4,2.41,7.5.6,5.21,1.34,11,1.59,14.68C371.28,225.73,358,226.49,352.15,223.62Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,195.8c0-.9-.14-3.49-.14-3.49a1.81,1.81,0,0,1-2.8.12c-1.39-1.3-1.62-2.76-1-3.8s2.42-1.31,3.33.34c.26.48,1.06.07,1.13-.33s-.19-1,.15-1.4a1.38,1.38,0,0,1,.43-.32,11.58,11.58,0,0,0,5.23-6.82c2.06.64,4.44,2.55,4.38,4.89a14,14,0,0,0,.37,2.89c.25,2.79-.17,4.82-1.2,5.79a4.83,4.83,0,0,1-3.19,1.07s0,.34,0,.93c0,0,.28.81.9.94.42.09,1.46.27,1.46.27s1.6,2.1-2.19,2.78c-6,1.09-8.84-1.77-8.84-1.77s.25-.1,1.19-.41S358,196.69,357.92,195.8Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,194.74c-2.65,0-5.11-.66-5.84-2.54a2.9,2.9,0,0,0,1.53,2.52,11.84,11.84,0,0,0,4.34.95Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.74,190.06l2.33.71a1.2,1.2,0,0,1-1.5.85A1.28,1.28,0,0,1,362.74,190.06Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9,190.59a1.33,1.33,0,0,1,1.34,1,1.09,1.09,0,0,1-.67,0,1.23,1.23,0,0,1-.85-1Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.91,185.09l-1.56-.58a.8.8,0,0,1,1-.5A.87.87,0,0,1,367.91,185.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,185.46l1.44-.85a.79.79,0,0,0-1.12-.32A.87.87,0,0,0,360.9,185.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,186.59a.64.64,0,0,1-.64.63.64.64,0,0,1,0-1.27A.64.64,0,0,1,362.7,186.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.7,186.25a.64.64,0,0,1-.64.63.64.64,0,0,1,0-1.27A.64.64,0,0,1,367.7,186.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.06 188.48 364.96 189.29 364.35 185.46 367.06 188.48",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.83,231.72l0-.05,11.48-26.5h0a1.77,1.77,0,0,0-.3-1.78,5.63,5.63,0,0,0-4.59-2.18,1.82,1.82,0,0,0-1.6.87h0L375.8,227.36l0,0a.41.41,0,0,1,0,.09,4.94,4.94,0,0,0,2.31,6.67,5.11,5.11,0,0,0,6.76-2.36A.36.36,0,0,0,384.83,231.72Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.45,201.21c-1.63.13-2.21,1.31-1.3,2.64a5.59,5.59,0,0,0,4.59,2.18c1.63-.12,2.21-1.3,1.3-2.64A5.62,5.62,0,0,0,391.45,201.21Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.22,227.56l12-22.6a4.55,4.55,0,0,1-1.12-1.11,1.76,1.76,0,0,1-.31-1.76l-14,25.27,0,0a.41.41,0,0,1,0,.09,4.94,4.94,0,0,0,2.31,6.67C376.8,233.14,377.65,230.54,379.22,227.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.26,194.58a3.37,3.37,0,0,0-2.78-1.32,1.14,1.14,0,0,0-1,.52h0l-4.38,8.91h0a1.08,1.08,0,0,0,.18,1.07,3.38,3.38,0,0,0,2.78,1.32,1.1,1.1,0,0,0,1-.52l4.38-8.91h0A1.08,1.08,0,0,0,399.26,194.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,198.68l1.63-3.31q1.75,1.41,3.56,2.62l-1.6,3.26Q394.86,200,393.1,198.68Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31,168.27c0,11.8,8.29,26.15,18.5,32a16.77,16.77,0,0,0,8.27,2.53,9.52,9.52,0,0,0,4.82-1.23l4.41-2.52c3.35-1.94,5.42-6.08,5.42-12,0-11.81-8.29-26.16-18.51-32.06-5.11-2.94-9.73-3.22-13.08-1.29l-4.42,2.52C381.38,158.23,379.31,162.37,379.31,168.27Zm34.07,21.37a14,14,0,0,1-1.48,6.82,7.5,7.5,0,0,1-.7,1,8.19,8.19,0,0,1-.87,0,14,14,0,0,1-6.79-2.13c-4.51-2.6-8.77-7.12-12-12.73s-5-11.57-5-16.77c0-3.42.77-6.11,2.18-7.87a8,8,0,0,1,1-.05,14.18,14.18,0,0,1,6.64,2.13c4.51,2.6,8.77,7.12,12,12.74S413.38,184.44,413.38,189.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,163.91l-7,4a42.11,42.11,0,0,1,3.34,5c.2.34.4.69.59,1l6.95-4A44.55,44.55,0,0,0,412,163.91Zm-11.6-.88a33.36,33.36,0,0,1,2.58,2.49l7-4c-.81-.89-1.64-1.73-2.5-2.52Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.92,201.6l4.39-2.5c3.35-1.94,5.42-6.08,5.42-12,0-.23,0-.46,0-.68l-4.4,2.51c0,.23,0,.46,0,.69C416.32,195.52,414.26,199.66,410.92,201.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.25,168.27c0,5.2,1.78,11.16,5,16.77s7.51,10.14,12,12.74a14.12,14.12,0,0,0,6.8,2.13h.38a6.23,6.23,0,0,0,4.74-2.39,8.19,8.19,0,0,1-.87,0,14,14,0,0,1-6.79-2.13c-4.51-2.6-8.77-7.12-12-12.73s-5-11.57-5-16.77c0-3.42.77-6.11,2.18-7.87a6.21,6.21,0,0,0-4.48,2.65A13,13,0,0,0,382.25,168.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31,168.27c0,11.8,8.28,26.15,18.5,32s18.51,1.12,18.51-10.68-8.29-26.15-18.51-32S379.31,156.47,379.31,168.27Zm8,16.77c-3.24-5.61-5-11.57-5-16.77,0-6.43,2.73-10.27,7.3-10.27h.15a14.18,14.18,0,0,1,6.64,2.13c4.51,2.6,8.77,7.13,12,12.74s5,11.57,5,16.77a14,14,0,0,1-1.48,6.82,6.36,6.36,0,0,1-5.82,3.45,14.12,14.12,0,0,1-6.8-2.13C394.78,195.18,390.52,190.65,387.27,185Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.83,173.09a42.63,42.63,0,0,1,3.76,10.52,29.58,29.58,0,0,1,.63,5.54,21,21,0,0,1-.61,5.53,12.34,12.34,0,0,1-2.45,4.94,8.94,8.94,0,0,1-4.65,2.87,11.58,11.58,0,0,1-5.52-.09,19.66,19.66,0,0,1-5.18-2.08,20.09,20.09,0,0,0,5.16,2.19,11.79,11.79,0,0,0,5.57.12,9.08,9.08,0,0,0,4.76-2.89,12.46,12.46,0,0,0,2.52-5,20.64,20.64,0,0,0,.58-5.59,29.85,29.85,0,0,0-.67-5.57,40,40,0,0,0-1.57-5.38A45.25,45.25,0,0,0,411.83,173.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.55,158a7.08,7.08,0,0,0-2.72.49,6.33,6.33,0,0,0-2.25,1.61,8.57,8.57,0,0,0-1.46,2.38,12.62,12.62,0,0,0-.77,2.68,21.65,21.65,0,0,0-.16,5.57,30.87,30.87,0,0,0,1,5.47,34.81,34.81,0,0,0,1.91,5.23,41.31,41.31,0,0,0,2.61,4.92,38.18,38.18,0,0,0,7.1,8.57,27,27,0,0,0,4.55,3.24,15.72,15.72,0,0,0,5.28,1.91,8.74,8.74,0,0,0,2.84,0,6.32,6.32,0,0,0,2.62-1.16,5.73,5.73,0,0,0,1.05-1,7.22,7.22,0,0,0,.83-1.16,10.05,10.05,0,0,0,1.05-2.62,18.69,18.69,0,0,0,.47-5.57,29.06,29.06,0,0,0-.86-5.49,37.06,37.06,0,0,0-1.8-5.26,40.9,40.9,0,0,0-2.53-4.93,40.12,40.12,0,0,1,4,10.26,28.53,28.53,0,0,1,.77,5.44,18.31,18.31,0,0,1-.54,5.43,9.7,9.7,0,0,1-1,2.49,6.72,6.72,0,0,1-1.76,2,5.9,5.9,0,0,1-2.41,1,8,8,0,0,1-2.67,0,15,15,0,0,1-5.08-1.87,26.28,26.28,0,0,1-4.44-3.19,37.57,37.57,0,0,1-7-8.41,41.35,41.35,0,0,1-4.55-10,30,30,0,0,1-1.1-5.39,21.39,21.39,0,0,1,.07-5.48,12.19,12.19,0,0,1,.7-2.65,8,8,0,0,1,1.36-2.35,6.13,6.13,0,0,1,2.18-1.63A6.87,6.87,0,0,1,389.55,158Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.33,167.12c0,5.2,1.78,11.16,5,16.77s7.5,10.14,12,12.74a14.12,14.12,0,0,0,6.8,2.13,7.31,7.31,0,0,0,2.13-.31,7.07,7.07,0,0,0,1.61-2,14,14,0,0,0,1.48-6.82c0-5.2-1.78-11.16-5-16.77s-7.5-10.14-12-12.74A14.18,14.18,0,0,0,389.7,158h-.15a7,7,0,0,0-2.13.31C385.43,160,384.33,163,384.33,167.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.87,198.76c3,1.05,5.41,5,5.41,5l6.87,9.57s7.72,3.8,10.29,4.78c1.1.42,3-.2,4.45-.17.39,0,.75,0,1.09.06L379.92,220c-.59.44.73,1.15,2.4,1.49s3.68.15,4.25,1.17c.27.48,0,.68-.74.79.06.28,0,.61-.84.84a2.72,2.72,0,0,1-1.44,1.07,9.85,9.85,0,0,1-5.1-.41c-1.67-.73-2.8-1.72-4.56-2.24s-7.78-2.18-10.06-3.07-3.33-1.37-4.35-2.41a121.53,121.53,0,0,1-8.16-10.56C349.27,203.58,349.4,199.68,352.87,198.76Z",
    style: {
      fill: "#c8856a"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-451",
    d: "M412,339.73c8.89,5.14,23.31,5.14,32.2,0s8.9-13.46,0-18.59-23.31-5.13-32.2,0S403.13,334.6,412,339.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.49,317.06l-.66-5.91,7.84-1.16s-.27,3-.38,5.45a6.38,6.38,0,0,0,1.1,4.44,10.72,10.72,0,0,0,4.9,3.65c2.16.81,4.21,1.92,3.66,3.16s-3.75,1.85-5.15,1.59a22.33,22.33,0,0,1-6.12-3c-1.6-1.13-4.21-1.63-4.81-1.88s-.77-1.09-.78-2.5A31.78,31.78,0,0,1,430.49,317.06Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.57,260.57c.35,4,.33,15.43.2,23.86-.06,4-.67,9.62-.78,11.39-.31,5-1.21,16.41-1.21,16.41s-4.15,1.74-7.92.33c-.75-6.24-3.12-15.08-1.56-20.43l-3.66-31.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.32,291.88c.15-1.59-.48-16.44-.48-16.59h.33c0,.61.64,15,.49,16.63a14.14,14.14,0,0,1-.26,1.51,28.09,28.09,0,0,0-.59,7.79c.18,3.33.48,8.41.68,11.77a2,2,0,0,1-.34-.06c-.2-3.36-.5-8.39-.67-11.7a27.88,27.88,0,0,1,.59-7.87C431.18,292.79,431.28,292.3,431.32,291.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.3,292.13l-1.84-16.78c5.42-.85,9.16-3.63,10.11-5.88a7.94,7.94,0,0,1-4.69,6s-1.07,10.36-1.6,14S429,295,428.07,300.87A23.22,23.22,0,0,1,428.3,292.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.37,326.78a1.66,1.66,0,0,1-.31,1.68,7.2,7.2,0,0,1-5.25,1.2,9.12,9.12,0,0,1-5.06-2,10.82,10.82,0,0,0-3.69-2.34,11.35,11.35,0,0,1-3.23-1.18c-.35-.34-.31-1.84-.31-1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.49,317.06a.79.79,0,0,0-.42.51c-.08.41-.08.94-.25,1.62a12.13,12.13,0,0,0-.25,3.64c.15.77,2.53,1.41,3.67,1.84a14.6,14.6,0,0,1,3.7,2.31,10.81,10.81,0,0,0,5.51,2c2.59,0,4.27-.67,4.78-1.6a2.21,2.21,0,0,0-.63-2.54,14.93,14.93,0,0,0-3.16-1.8,11.65,11.65,0,0,1-4.69-3.46,4.12,4.12,0,0,1-.72-2.31.82.82,0,0,0,0-.38.72.72,0,0,0-.6-.31,7,7,0,0,0-3.56.84,1.3,1.3,0,0,0-.72.48c-.32.52.09,1.18,0,1.77a.36.36,0,0,1,0,.11c-.08.13-.27.1-.39,0-.47-.26-.6-.85-.88-1.3a2.21,2.21,0,0,0-.9-.84,3.12,3.12,0,0,0-.36-.14S430.48,317.06,430.49,317.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.75,323.69a5.23,5.23,0,0,0-5,4.76,8.48,8.48,0,0,0,2.67.55c2.59,0,4.37-.67,4.89-1.6S447.41,324.69,444.75,323.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.58,324.24a.15.15,0,0,1-.11,0,.18.18,0,0,1,0-.25,4.4,4.4,0,0,1,3.32-1.61.18.18,0,0,1,.16.2.19.19,0,0,1-.2.17,4,4,0,0,0-3,1.47A.17.17,0,0,1,439.58,324.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,323.31a.15.15,0,0,1-.11,0,.19.19,0,0,1,0-.26,4.36,4.36,0,0,1,3.32-1.6.18.18,0,0,1,0,.36,4.07,4.07,0,0,0-3,1.47A.15.15,0,0,1,438,323.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.46,322.24a.15.15,0,0,1-.11,0,.18.18,0,0,1,0-.25,4.42,4.42,0,0,1,3.32-1.61.18.18,0,0,1,.16.2.19.19,0,0,1-.2.17,4.06,4.06,0,0,0-3,1.47A.17.17,0,0,1,436.46,322.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.07,321a.15.15,0,0,1-.11,0,.19.19,0,0,1,0-.26,4.55,4.55,0,0,1,3.63-1.62.18.18,0,0,1,.16.2.2.2,0,0,1-.2.17,4.19,4.19,0,0,0-3.3,1.48A.18.18,0,0,1,435.07,321Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.93,310.58c-1.5,1.1-5.81,2.17-8.33.49l.49,3.13c1.51,1,5.94,1.28,7.66-.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.2,321.57l-.16-6.94,7.78.29-1.14,7s-.45,2.85-.55,3.54a54.92,54.92,0,0,0-.41,5.94c0,2.62-.17,5.05-.89,6.25a1.94,1.94,0,0,1-2.67,1,5.12,5.12,0,0,1-3.06-3.79,14.11,14.11,0,0,1,.44-5.86A48.33,48.33,0,0,0,415.2,321.57Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.26,276.1c0,6.69.38,16.7.38,16.7a35.59,35.59,0,0,0-1.32,10.26c.06,5.5.63,14.85.63,14.85s1.14,1.2,4.08,1.38c2.63.16,3.45-1.15,3.45-1.15s3.49-17.41,4.29-21.85,4.36-30.72,4.86-34.58l-15.39.08C415.3,267.26,415.27,269.41,415.26,276.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.34,334.68a8.6,8.6,0,0,1-1,4.15,2.74,2.74,0,0,1-3.12,1.15c-1.26-.3-2.87-1.11-3.25-2.69a10,10,0,0,1-.35-4.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.2,321.57c-.52.05-.34,2.48-.6,4.95-.28,2.65-.65,3.7-.9,5.88a6.74,6.74,0,0,0,1,5.06c.89,1.48,4,2.9,5.49.73,1.21-1.77,1.24-3.71,1.09-6.18a35.23,35.23,0,0,1,.25-6.21c.18-2,.57-3.66.12-3.86,0,0-.3,1.52-.42,1.84-.05.14-.24.49-.33,0,0-.15,0-.51,0-.66,0-.43-.3-.49-.47-.58a4.94,4.94,0,0,0-2.2-.45,5.87,5.87,0,0,0-2.44.29c-.33.18-.32.5-.35.81s0,.6-.13.53A10.25,10.25,0,0,1,415.2,321.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,333.83a6.12,6.12,0,0,0,1,3.75c.9,1.48,4.25,2.9,5.74.73a7,7,0,0,0,1-3.63C420.41,333,415,332.4,413.58,333.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.18,332l-.06,0a8.83,8.83,0,0,0-4.73-.38.19.19,0,0,1-.23-.14.18.18,0,0,1,.14-.23,9.09,9.09,0,0,1,5,.4.21.21,0,0,1,.09.26A.21.21,0,0,1,420.18,332Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.48,329.76a.18.18,0,0,1-.17-.12.21.21,0,0,1,.12-.25,7.55,7.55,0,0,1,5,.36.19.19,0,0,1,.08.26.18.18,0,0,1-.25.08,7.29,7.29,0,0,0-4.67-.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.53,328a.2.2,0,0,1-.16-.12.19.19,0,0,1,.11-.25,6.76,6.76,0,0,1,5.07.35.19.19,0,1,1-.2.32,6.53,6.53,0,0,0-4.73-.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.63,326.3a.18.18,0,0,1-.16-.12.18.18,0,0,1,.11-.24,7.08,7.08,0,0,1,5.1.39.19.19,0,0,1-.19.34,6.73,6.73,0,0,0-4.77-.38A.14.14,0,0,1,415.63,326.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,316.06c-1.6.9-5.92,1.45-8.18-.53l.1,3.17c1.37,1.14,5.65,2,7.56.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.19,316.93h.34a124,124,0,0,1,.67-19.68c.1-.86.2-1.53.3-2.19a110.65,110.65,0,0,0,1.05-12.58c.15-3.13.17-5.54.18-7.66v-.44c2.23-.08,3.55-2.21,4-6.49s1-7.36,1-7.39l-.33-.05s-.49,3-1,7.4C421,272,419.79,274,417.73,274a56.2,56.2,0,0,1,1.17-12.26h-.35a58.51,58.51,0,0,0-1.16,13c0,2.13,0,4.53-.18,7.65a107.45,107.45,0,0,1-1,12.55c-.09.66-.19,1.34-.3,2.19A124.88,124.88,0,0,0,415.19,316.93Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.9,236c2.94.45,3.44,1.2,7.79,5a31.72,31.72,0,0,0,6.25,4.36s3.67,4.47,3.82,5.34.46,2.84-1.27,3.93c-1.11.7-2.39.06-3.07.13-1.43.13-2.31-1-2.9-1.38-4-2.39-8-4.57-8-4.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.19,233.52c-.6-.36-.71.2-.91.27,0,0,.62-.71-.42-1.32-.64-.38-.95.51-1,.39s.77-1.87,1.4-3.42.08-1.88-.16-2-.48,0-1,1.05-2.19,4.26-2.56,4.93-.63,1-.87.11a4.8,4.8,0,0,0-.89-2.07c-.79-.83-1.4-.47-1.28.17.17.89.16,1.94.29,3.4.06.76.08,1.47.17,2,.27,1.83-.8,2.67-2.07,4.11-1.05,1.18-2.12,2.14-4.51,4.5s-2.18,7.51.06,8.43c2.57,1.07,3.6-.29,5.46-3.13,1.58-2.41,3.76-6.8,4.35-7.82s.81-1.64,1.62-2.14a5.91,5.91,0,0,0,2.23-2.48c.3-.52.86-1.46,1.22-2.23s.4-1.31,0-1.64c-.6-.44-.77.22-.83.15S464.05,234,463.19,233.52Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.59,234.78a5.65,5.65,0,0,1,1.06,4.48A3.15,3.15,0,0,0,458.59,234.78Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,233.34a4.89,4.89,0,0,0-.83,2.29.63.63,0,0,0,.75.52,1.21,1.21,0,0,0,.52-.29,1,1,0,0,0-.12.7.72.72,0,0,0,.84.38,1,1,0,0,0,.5-.41s-.21.54,0,.83a.67.67,0,0,0,1-.09c-.24.42-.59.66-1,.44s-.33-.56-.33-.56a.89.89,0,0,1-1.3-.83.72.72,0,0,1-1.13-.38c-.19-.55,0-.95.36-1.59A4.32,4.32,0,0,1,460.7,233.34Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.15,235c-1.25.31-5,1.25-7.17,1.9,0,0-1.63.63-1.45,1.47a47.56,47.56,0,0,0,.84,10.77,25.81,25.81,0,0,1,.7,6.59c-.11,4-.42,5.45-.67,8.77,0,0,4,4,14.94,3.33,7.33-.43,9.47-3.68,9.47-3.68s0-10.19-.17-15.59c-.24-7.09-1.77-11.36-3.58-12.54l-5.27-.95Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm-with-scissors--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416,236.89c-1.8.42-3.49,1-4.72,4.26-1,2.68-3.26,9.15-4.39,12.26-1.62,4.47-2.15,6.88-1.89,7.62.6,1.71,1.54,2,8.14,4.51.34-2.05,2.81-4.93,3.86-5.22l-3.31-2.39,4.21-9.2S419.25,240.13,416,236.89Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.14,218.84l-2.31.17,2.38,10.64L407.57,233l-1.47-.57-2.41-10.74-2.31.17a8,8,0,0,0-.41.77c-2.33,4.74-1.8,12.16,1.17,16.58,1.5,2.22,3.33,3.25,5.07,3.12h0l2.31-.17.42-.06,34.43,50.46a18.45,18.45,0,0,0,2.45,12.14,6.84,6.84,0,0,0,3.72,3l2.31-.17-2.38-10.64,1.64-3.34,1.47.57L456,304.85l2.31-.17c.15-.25.28-.5.42-.77,2.32-4.74,1.79-12.16-1.18-16.58-1.48-2.2-3.28-3.23-5-3.13h-.07l-2.23.16h0a4.26,4.26,0,0,0-.5.06L415.32,234a18.51,18.51,0,0,0-2.46-12.14A6.84,6.84,0,0,0,409.14,218.84Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.14,218.84l-2.31.17,2.38,10.64L407.57,233l-1.47-.57-2.41-10.74-2.31.17a8,8,0,0,0-.41.77c-2.33,4.74-1.8,12.16,1.17,16.58,1.5,2.22,3.33,3.25,5.07,3.12h0l2.31-.17.42-.06,34.43,50.46a18.45,18.45,0,0,0,2.45,12.14,6.84,6.84,0,0,0,3.72,3l2.31-.17-2.38-10.64,1.64-3.34,1.47.57L456,304.85l2.31-.17c.15-.25.28-.5.42-.77,2.32-4.74,1.79-12.16-1.18-16.58-1.48-2.2-3.28-3.23-5-3.13h-.07l-2.23.16h0a4.26,4.26,0,0,0-.5.06L415.32,234a18.51,18.51,0,0,0-2.46-12.14A6.84,6.84,0,0,0,409.14,218.84Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.21 229.65 411.52 229.47 409.45 233.72 407.57 232.99 409.21 229.65",
    style: {
      fill: "#8E4DFE",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.58 294.11 455.9 293.94 452.55 292.64 452.11 293.54 453.58 294.11",
    style: {
      fill: "#8E4DFE",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.37 292.55 446.68 292.38 411.81 241.26 409.49 241.44 444.37 292.55",
    style: {
      fill: "#8E4DFE",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.19,285.09,415.32,234a18.51,18.51,0,0,0-2.46-12.14,6.84,6.84,0,0,0-3.72-3l2.38,10.63-2.07,4.25-3.35-1.3-2.41-10.74c-.14.24-.28.49-.41.76-2.32,4.75-1.79,12.17,1.17,16.58,2.18,3.24,5.06,3.95,7.36,2.24l34.87,51.12a18.48,18.48,0,0,0,2.45,12.13,6.9,6.9,0,0,0,3.72,3l-2.38-10.64,2.08-4.24,3.35,1.3,2.4,10.74c.15-.25.28-.5.42-.77,2.32-4.74,1.79-12.16-1.18-16.58C455.36,284.1,452.49,283.39,450.19,285.09Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.19,285.09,415.32,234a18.51,18.51,0,0,0-2.46-12.14,6.84,6.84,0,0,0-3.72-3l2.38,10.63-2.07,4.25-3.35-1.3-2.41-10.74c-.14.24-.28.49-.41.76-2.32,4.75-1.79,12.17,1.17,16.58,2.18,3.24,5.06,3.95,7.36,2.24l34.87,51.12a18.48,18.48,0,0,0,2.45,12.13,6.9,6.9,0,0,0,3.72,3l-2.38-10.64,2.08-4.24,3.35,1.3,2.4,10.74c.15-.25.28-.5.42-.77,2.32-4.74,1.79-12.16-1.18-16.58C455.36,284.1,452.49,283.39,450.19,285.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.32,240.27,446.5,283a4,4,0,0,1,.4,3.63c-.47,1-1.42,1-2.11,0l-29.18-42.78a4,4,0,0,1-.4-3.63C415.68,239.23,416.63,239.26,417.32,240.27Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.32,283.12l-29.18-42.76a2,2,0,0,0-.6-.6,1.51,1.51,0,0,0-.33.46,4,4,0,0,0,.4,3.63l29.18,42.78a2.08,2.08,0,0,0,.6.59,1.4,1.4,0,0,0,.33-.46A4,4,0,0,0,445.32,283.12Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.11 293.54 452.55 292.64 455.9 293.94 458.3 304.68 455.99 304.85 453.58 294.11 452.11 293.54",
    style: {
      fill: "#8E4DFE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.14 218.84 411.52 229.47 409.45 233.72 411.91 229.56 409.14 218.84",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.85 307.52 449.98 296.79 452.55 292.64 450.47 296.88 452.85 307.52",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.15,265.54c2.84,1.29,6.18,2.8,7.36,3.28a14.62,14.62,0,0,0,5.78,1.06c1.66,0,2.83.06,4.18-1.27a7.36,7.36,0,0,0,2-3.45c.08-.48-.76-1.16-.76-1.16s-.11-1-1.41-.82-2,1.06-3.33,1.09a5.48,5.48,0,0,1-2.06-.27l-1-1.45a16.1,16.1,0,0,0-1.59.71c-.35.14-3-1.48-5.29-2.94h0C416,260.62,413.49,263.5,413.15,265.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-451"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.55,225.18c.44,2.09,1.13,6,3.08,7,0-1.43,0-3.56-.05-5,.46,0,2.56-3.18,1.85-4.55,3.19.35,8.8,4,9.83.92,3-9-11.93-9.75-13.26-3.71C420.14,220.4,420.11,223.08,420.55,225.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.93,230a1.56,1.56,0,0,0,2.2-.4v5.79c2.84,4,10.71,3.05,7.6,0l0-1.38a9.48,9.48,0,0,0,1.32-.1,3.35,3.35,0,0,0,2.67-2.67A20.37,20.37,0,0,0,435,222a2.51,2.51,0,0,0-1.07-1.84c-1.59-.84-3.12.27-5.39,1.08a7.77,7.77,0,0,1-3.8.14c.77.89.68,3.63-.5,4.71a2.82,2.82,0,0,1-.6.74c-.51.41-.88-.7-1.28-1.15s-2.15-1-2.66.54A3.44,3.44,0,0,0,420.93,230Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.47,229l2.08.34a1,1,0,0,1-1.19.9A1.1,1.1,0,0,1,429.47,229Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.73,229.36a1.06,1.06,0,0,0-.25,0,1.07,1.07,0,0,0,.88.9.81.81,0,1,0-.63-.92Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.89,223.42l-1.51.61a.87.87,0,0,1,.47-1.09A.8.8,0,0,1,428.89,223.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.47,223.37l-1.56-.49a.79.79,0,0,1,1-.55A.86.86,0,0,1,434.47,223.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,225.05a.66.66,0,0,0,1.32,0,.67.67,0,0,0-.67-.66A.65.65,0,0,0,428,225.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,224.69a.66.66,0,0,0,.66.66.67.67,0,0,0,.66-.67.66.66,0,0,0-.67-.65A.65.65,0,0,0,433,224.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.68,223.67l.42,4.22,2.25-.76A10,10,0,0,0,430.68,223.67Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.91,226.46c.37.58,0,2.06,1.12,5.14.35,1,1.44,2.05,4.13,2.58s4.87.12,5.89-.78a5.13,5.13,0,0,0,1.36-3.18,23.22,23.22,0,0,0,0-4.72,9.92,9.92,0,0,1-.39,3.12c-.22.56-.7.47-1.32.23a5.63,5.63,0,0,0-2.81-.75c-2.42.06-3,.85-4.44.83-1,0-2-.32-2.23-3.19C424.23,225.74,422.54,225.88,422.91,226.46Zm5.48,3.92c0-.95.81-1.48,2.19-1.48,1.57,0,2.23.66,2.26,1.44.05,1.17-.13,1.86-.89,1.95s-.94,0-.95-.3,0-.73.1-.87.2-.3-.43-.3-.68,0-.46.3a1.55,1.55,0,0,1,.11.86c0,.39-.46.36-1.07.29S428.33,231.74,428.39,230.38Z",
    style: {
      fill: "#37474f"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterfallmethodAmico);
export default __webpack_public_path__ + "static/media/waterfall method-amico.c6e047c403211f5ff341a38a82ccd10e.svg";
export { ForwardRef as ReactComponent };